<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-clip-rotate-multiple"
    [fullScreen]="true">
    <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>

<p-toast position="top-right"></p-toast>
<app-confirm-dialog
    [visible]="memberConfirmVisible"
    variant="secondary"
    [heading]="memberConfirmHeading"
    [message]="memberConfirmMessage"
    [slideText]="memberConfirmSlideText"
    [doneText]="memberConfirmDoneText"
    [cancelText]="memberConfirmCancelText"
    [iconClass]="memberConfirmIconClass"
    [slideIconClass]="memberConfirmSlideIconClass"
    [cancelIconClass]="memberConfirmCancelIconClass"
    [confirmText]="memberConfirmConfirmText"
    [confirmIconClass]="memberConfirmConfirmIconClass"
    (confirmed)="runMemberConfirmation()"
    (cancelled)="cancelMemberConfirmation()">
</app-confirm-dialog>
<div class="p-g add-member-res">
    <div class="p-g-12 mobile-padding-0" *ngIf="mode == 'add'">
        <app-signup></app-signup>
    </div>
    <div class="p-g-12 mobile-padding-0" *ngIf="mode == 'edit'">
        <div class="p-g">
            <div class="p-g-12 mobile-padding-0">
                <p-toolbar>
                    <div style="gap:.5em" class="p-toolbar-group-left memberDetailsButton p-toolbar-tecfolk-fix">
                        <button routerLink="/members"
                                (click)="markMemberGoBack()"
                                *ngIf="mode == 'edit'"
                                pButton
                                type="button"
                                [label]='setLabel("goBackBtnLabel")'
                                icon="pi pi-arrow-left">
                        </button>
                        <button routerLink="/members/member" pButton type="button" style="background-color: #5192d0"
                            [label]='setLabel("newBtnLabel")' icon="pi pi-plus"></button>
                        <button (click)="update(memberSignUpForm)" [disabled]="!member.contactDetail.contact ||
                        isGymShareMoreThanTrainerFee ||
                            isEmailExist" pButton type="button" [label]='setLabel("updateBtnLabel")'
                            icon="pi pi-save" class="p-button-success"></button>
                        <button (click)="payFee()" *ngIf="mode == 'edit'" pButton type="button"
                            [label]='setLabel("addFeeBtnLabel")' icon="pi pi-plus" class="p-button-primary"
                            style="background-color: #3f51b5"></button>
                        <button (click)="deActivateMember()" *ngIf="member.isDelete === false" pButton type="button"
                            [label]='setLabel("deactivateMemberBtnLabel")' icon="fa fa-times"
                            class="p-button-danger"></button>
                        <button (click)="freezeMember(member)" class="p-button-info"
                            *ngIf="member.freezeDetail.isFreeze === false && !shouldHideFreezeMemberButton()" pButton type="button"
                            [label]='setLabel("freezeMemberBtnLabel")' [disabled]="isFreezeDisabled(member)"
                            [ngClass]="{'freeze-disabled-btn': isFreezeDisabled(member),
                                        'freeze-enabled-btn': !isFreezeDisabled(member)}"
                                    icon="fa fa-thermometer-empty"></button>
                        <button (click)="IsSyncedMember(member)" class="p-button-info"
                            style="background-color: #0adf63;" *ngIf="member.freezeDetail.isFreeze === false" pButton
                            type="button" [label]='setLabel("syncAgainBtnLabel")' icon="fa fa-spinner"></button>
                        <button (click)="openWhatsAppWelcome()" class="p-button-info" style="background-color: #0adf63;"
                            *ngIf="welcomeMsg == true" pButton type="button" [label]='setLabel("welcomeMsgBtnLabel")'
                            icon="fa fa-whatsapp"></button>
                        <button *ngIf="branch.permissions.complimentaryFreezingDays " (click)="addFreezingDays()"  class="p-button-info" style="background-color: #5095d2;"
                             pButton type="button" [label]='setLabel("extendFreezeBtnLabel")'
                            icon="fa fa-plus"></button>
                        <button (click)="activateMember()" class="p-button-primary" *ngIf="member.isDelete === true"
                            pButton type="button" [label]='setLabel("activateBtnLabel")' icon="fa fa-times"
                            style="background-color: #e91e63"></button>
                        <button (click)="defreezeMember(member)" *ngIf="member.freezeDetail.isFreeze === true" pButton
                            type="button" [label]='setLabel("defreezeBtnLabel")' icon="fa fa-thermometer-empty"
                            class="p-button-primary" style="background-color: #3f51b5"></button>
                        <button pButton
                            *ngIf="canAddSubscription && subscriptionTabActive && (branch.gymPackage =='premium' || branch.gymPackage =='enterprise') "
                            icon="pi pi-plus" class="p-button-success"
                            (click)="openAddSubscriptionDialog()">{{setLabel("addSubscriptionHeaderLabe")}}</button>
                    </div>
                </p-toolbar>
            </div>
            <div class="feeDetailsHeader">
                <div class="feeDetailsHeaderField">
                    <p class="memberTagText">
                        {{setLabel("membershipNumberLabel")}}
                    </p>
                    <p>{{member.tagNumber}}</p>
                </div>
                <div class="feeDetailsHeaderField">
                    <p class="memberTagText">
                        {{setLabel("nameLabel")}}
                    </p>
                    <p>{{member.name}}</p>
                </div>
                <div class="feeDetailsHeaderField" *ngIf="member.settings && member.settings.dueDate">
                    <p class="memberTagText">
                        {{setLabel("monthlyDueDayLabel")}}
                    </p>
                    <p>
                        {{member.settings.dueDate | date : "d"}}
                        <sup>{{getNthTypeDay(member.settings.dueDate | date : "d")}}</sup>
                        &nbsp;{{member.settings.dueDate | date : "MMM"}}
                    </p>
                </div>
                <div class="feeDetailsHeaderField"
                    *ngIf="member.settings && member.settings.dueDate && member.freezeDetail.isFreeze === false">
                    <p class="memberTagText">
                        Days Left
                    </p>
                    <p>{{ getPackageValidityData(member.settings.dueDate) }}</p>
                </div>
                <div class="feeDetailsHeaderField"
                    *ngIf="member.customerstrainer && member.customerstrainer.dueDate && member.question3 === 'YES'">
                    <p class="memberTagText">
                        {{setLabel("trainerLabel")}}

                    </p>
                    <p>{{member.customerstrainer.name}}</p>
                </div>
                <div class="feeDetailsHeaderField"
                    *ngIf="member.customerstrainer && member.customerstrainer.dueDate && member.question3 === 'YES'">
                    <p class="memberTagText">
                        {{setLabel("trainerDueDayLabel")}}

                    </p>
                    <p>
                        {{member.customerstrainer.dueDate | date : "d"}}
                        <sup>{{getNthTypeDay(member.customerstrainer.dueDate| date : "d")}}</sup>
                        &nbsp;{{member.customerstrainer.dueDate | date : "MMM"}}
                    </p>
                </div>
            </div>
            <div class="p-g-12 mobile-padding-0 add-member-res-tabs">
                <p-tabView #memberTabView [activeIndex]="index" (onChange)="handleChange($event)">
                    <p-tabPanel [header]='setLabel("detailsLabel")'>
                        <div class="card card-w-title mobile-padding-0 add-member-res-tab-Details">
                            <div class="profileImgContainer">
                                <div *ngIf="canShowMemberImage()" class="p-g-3 imgstyle" [ngStyle]="{ opacity: getMemberOpacity(member) }">
                                    <img style="width: 200px; height: 200px" [src]="memberImageSrc(member)" (error)="onImageError($event)" />
                                </div>

                                <div class="userDetailToolBar">
                                    <h3 class="first">{{setLabel("profilePictureLabel")}}</h3>
                                    <button pButton (click)="showAddProfileImage('Cam')" class=""
                                        [pTooltip]='setLabel("capturePhotoBtnLabel")' tooltipPosition="top">
                                        <span class="p-button-text p-c">
                                            <i class="fa fa-camera" aria-hidden="true"></i>
                                            &nbsp;{{setLabel("capturePhotoBtnLabel")}}
                                        </span>
                                    </button>
                                    <button pButton (click)="showAddProfileImage('Upload')" class=""
                                        [pTooltip]='setLabel("uploadPhotoBtnLabel")' tooltipPosition="top">
                                        <span class="p-button-text p-c">
                                            <i class="fa fa-upload" aria-hidden="true"></i>
                                            &nbsp;{{setLabel("uploadPhotoBtnLabel")}}
                                        </span>
                                    </button>
                                    <button pButton (click)="openWhatsAppProfile(member)" class=""
                                        [pTooltip]='setLabel("sendOnlineLinkForUploadingPhotoPtooltipLabel")'
                                        tooltipPosition="top">
                                        <span class="p-button-text p-c">
                                            <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                            &nbsp;{{setLabel("onlinePhotoBtnLabel")}}
                                        </span>
                                    </button>
                                    <button pButton (click)="removeProfileImage()" class="removePhoto"
                                        [pTooltip]='setLabel("removePhotoBtnLabel")' tooltipPosition="top">
                                        <span class="p-button-text p-c">
                                            <i class="fa fa-times"></i>
                                            &nbsp;{{setLabel("removePhotoBtnLabel")}}
                                        </span>
                                    </button>
                                    <button pButton (click)="printMemberDetails(member)" class=""
                                        [pTooltip]='setLabel("printDetailsBtnLabel")' tooltipPosition="top">
                                        <span class="p-button-text p-c">
                                            <i class="fa fa-print" aria-hidden="true"></i>
                                            &nbsp;{{setLabel("printDetailsBtnLabel")}}
                                        </span>
                                    </button>
                                    <!-- <button (click)="showAddProfileImage()" class="">
                                        Add Profile Pic
                                    </button> -->
                                </div>
                            </div>

                            <div class="p-g-12">
                                <form class="memberDetailForm" #memberSignUpForm="ngForm">
                                    <div class="p-g-6 memberForm" style="text-align: left">
                                        <h3 class="first">
                                            {{setLabel("membershipNoLabel")}}
                                            {{ member.tagNumber }}
                                            <span style="color: red">*</span>
                                        </h3>
                                        <div class="p-g p-fluid">
                                            <h3 class="first">
                                                {{setLabel("nameLabel")}}
                                                <span style="color: red">*</span>
                                            </h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-user"
                                                            aria-hidden="true"></i></span>
                                                    <input autocomplete="off" pattern="[A-Za-z ]+" [ngClass]="name.invalid && (name.dirty || name.touched) ? 'errorInput' : ''
                                                    " type="text" pInputText
                                                        [Placeholder]='setLabel("name*PlaceholderLabel")'
                                                        #name="ngModel" name="name" required [(ngModel)]="
                                                    member.name" />
                                                </div>
                                                <div>
                                                    <div *ngIf="name.errors?.['required']" class="errorShow">
                                                        {{setLabel("enternameLabel")}}
                                                    </div>
                                                    <div *ngIf="name.errors?.['pattern']" class="errorShow">
                                                        {{setLabel("namelettersLabel")}}

                                                    </div>
                                                </div>
                                            </div>
                                            <h3 class="first">{{setLabel("genderLabel")}}</h3>
                                            <div class="gender-Radio p-g-12">
                                                <div class="p-g-6">
                                                    <p-radioButton name="group1" [value]='setLabel("mValueLabel")'
                                                        [label]='setLabel("maleLabel")' [(ngModel)]="member.gender"
                                                        inputId="opt1">
                                                    </p-radioButton>
                                                </div>
                                                <div class="p-g-6">
                                                    <p-radioButton name="group1" [value]='setLabel("fValueLabel")'
                                                        [label]='setLabel("femaleLabel")' [(ngModel)]="member.gender"
                                                        inputId="opt2">
                                                    </p-radioButton>
                                                </div>
                                            </div>

                                             <h3 class="first">
                                            {{setLabel("mobileLabel")}}
                                            <span style="color: red">*</span>
                                        </h3>
                                        <div class="p-g p-fluid">

                                            <!-- Contact Field for Specific Roles -->
                                            <div *ngIf='this.currentUserData.role === "Super Admin" || this.currentUserData.role === "Admin" || this.currentUserData.role === "Trainer"'
                                                class="p-g-12">
                                                <div class="p-g-12">
                                                    <app-phone-input [placeholder]="setLabel('Mobile*Placeholder')"
                                                        [(phoneNumber)]="member.contactDetail.contact"
                                                        [initialCountry]="'PK'" (validNumber)="formattedNumber = $event"
                                                        (formattedForSaving)="member.contactDetail.contact = $event"
                                                        style="max-width: 600px;margin: auto; align-items: center;">
                                                    </app-phone-input>
                                                    <div *ngIf="!member.contactDetail.contact" class="validation-error"
                                                        style="color: red; text-align: start;">
                                                        {{setLabel("correctMobileNumberErrorLabel")}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div *ngIf='this.currentUserData.role === "Operator" && this.currentUserData.gender === "F" '
                                                class="p-g-12">
                                                <app-phone-input [placeholder]="setLabel('Mobile*Placeholder')"
                                                    [(phoneNumber)]="member.contactDetail.contact"
                                                    [initialCountry]="'PK'" (validNumber)="formattedNumber = $event"
                                                    (formattedForSaving)="member.contactDetail.contact = $event"
                                                    style="max-width: 600px; margin: auto; align-items: center;">
                                                </app-phone-input>
                                            </div>

                                            <div *ngIf='this.currentUserData.role === "Operator" && this.currentUserData.gender === "M"'
                                                class="p-g-12">
                                                <app-phone-input [placeholder]="setLabel('Mobile*Placeholder')"
                                                    [(phoneNumber)]="member.contactDetail.contact"
                                                    [initialCountry]="'PK'" (validNumber)="formattedNumber = $event"
                                                    (formattedForSaving)="member.contactDetail.contact = $event"
                                                    style="max-width: 600px; margin: auto; align-items: center;">
                                                </app-phone-input>
                                            </div>
                                            <h3 class="first">{{setLabel("emailLabel")}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-envelope-o"
                                                            aria-hidden="true"></i></span>
                                                    <input type="email" autocomplete="off" pInputText
                                                        [placeholder]="member.email ? '' : setLabel('emailLabel')"
                                                        name="email" #email="ngModel" id="email"
                                                        (ngModelChange)="checkEmailExistEvent($event)"
                                                        pattern="^(?!.*@[Tt][Ee][Ss][Tt]\.[Cc][Oo][Mm]$)\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                                        [(ngModel)]="member.email" />
                                                </div>

                                                <div class="p-g-8" style="padding-top: 0px">
                                                    <ng-template
                                                        [ngIf]="email.invalid && (email.dirty || email.touched)">
                                                        <div>
                                                            <div *ngIf="email.errors.required" class="errorShow">
                                                                {{setLabel("emailaddressLabel")}}

                                                            </div>
                                                            <div *ngIf="email.errors.pattern" class="errorShow">
                                                                {{setLabel("validemailLabel")}}

                                                            </div>
                                                        </div>
                                                    </ng-template>

                                                    <ng-template [ngIf]="isEmailExist">
                                                        <div
                                                            style="margin-left: 30px !important; color: red !important;">
                                                            {{setLabel("differentemailLabel")}}

                                                        </div>
                                                    </ng-template>
                                                </div>

                                                <div class="p-g-4" style="padding-top: 2px">
                                                    <ng-template [ngIf]="isEmailLoader">
                                                        <div class="p-g-12"
                                                            style="text-align: end; padding-top: 0px; padding-right: 0px;">
                                                            <div class="spinit">
                                                                <i class="fa fa-spinner" aria-hidden="true"></i>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>

                                            <h3 class="first">{{setLabel("bloodGroupLabel")}}</h3>
                                            <p-dropdown class="p-inputtext" [options]="bloodGroupOptions"
                                                name="bloodGroup" [(ngModel)]="member.bloodGroup"
                                                (onChange)="onBloodGroupChange($event)">
                                            </p-dropdown>
                                            <h3 class="first">{{setLabel('heightLabel')}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-arrows-v"
                                                            aria-hidden="true"></i></span>
                                                    <input type="number" pInputText placeholder="Enter Height"
                                                        name="height" [(ngModel)]="member.height" />
                                                </div>
                                            </div>

                                            <h3 class="first">{{setLabel('weightLabel')}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-heartbeat"
                                                            aria-hidden="true"></i></span>
                                                    <input type="number" pInputText placeholder="Enter Weight"
                                                        name="weight" [(ngModel)]="member.weight" />
                                                </div>
                                            </div>
                                            <h3 class="first">{{setLabel("cardDetailsLabel")}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-user-md"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" pInputText #CardNo="ngModel"
                                                        [placeholder]="member.cardNo ? '' : setLabel('cardNumberPlaceholderLabel')"
                                                        autocomplete="off" name="CardNo" [(ngModel)]="member.cardNo" />
                                                </div>
                                            </div>
                                            <h3 class="first">{{setLabel("commentLabel")}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o"
                                                            aria-hidden="true"></i></span>
                                                    <textarea rows="5" cols="80" name="description"
                                                        [(ngModel)]="member.description" pInputTextarea
                                                        [placeholder]="member.description ? '' : 'Enter your Comments Here' "></textarea>
                                                </div>
                                            </div>

                                            <div *ngIf="branchSessionStorage === '651a591aae5ff029ba201bd6'"
                                                style="width: 100%;">
                                                <div *ngIf="!this.member.acknowledgedImage" class="p-g-12 imgstyle"
                                                    style="display: flex;flex-direction: column; flex-grow: 1; align-items: center;">
                                                    <h3 style="width: 100%;" class="first">
                                                        {{setLabel("uploadAcknowledgedImageLabel")}}
                                                    </h3>

                                                    <button style="width: 50%;" pButton class="p-button-success"
                                                        pTooltip="Upload Receipt" tooltipPosition="top"
                                                        (click)="onAcknowledgeUploadButtonClick()">
                                                        <span class="p-button-text p-c">
                                                            <i class="fa fa-upload" aria-hidden="true"></i>
                                                            &nbsp;{{setLabel("uploadReceiptBtnLabel")}}
                                                        </span>
                                                    </button>
                                                </div>

                                                <input id="acknowledgeFileInput" type="file" style="margin-left: 30%;"
                                                    style="display: none" (change)="ChangeEvent($event)">

                                                <div *ngIf="this.member.acknowledgedImage" class="p-g-12 imgstyle">
                                                    <h3 style="width: 100%;" class="first">
                                                        {{setLabel("acknowledgedImageLabel")}}
                                                    </h3>
                                                    <div
                                                        style="display: flex; align-items: center; justify-content: center;">
                                                        <a style="padding-right: 1rem;"
                                                            (click)="openAcknowledgePhoto(member.acknowledgedImage)">
                                                            <i class="fa fa-paperclip fa-lg"
                                                                [pTooltip]='setLabel("viewImageTooltipLabel")'
                                                                tooltipPosition="top"
                                                                style="display: flex; align-items: center; justify-content: center; padding-left: 5px;"></i>
                                                        </a>
                                                        <h3 class="first"
                                                            style="cursor: pointer; font-size: 1.2em;font-weight: 400;"
                                                            (click)="openAcknowledgePhoto(member.acknowledgedImage)">
                                                            {{setLabel("viewImageLabel")}}</h3>
                                                    </div>
                                                </div>


                                            </div>
                                             <div class="p-g-12" *ngIf="branch?.permissions?.isreferralSourceAllowed">
                                                <h3 class="first">
                                                    {{ setLabel("referralSourceLabel") }}
                                                    <span style="color: red;">*</span>
                                                </h3>
                                                <div class="p-inputgroup">
                                                    <p-dropdown class="p-inputtext" [options]="referralOptions" name="referralSource" id="referralSource"
                                                        [(ngModel)]="member.referralSource" #referralSource="ngModel"
                                                        [placeholder]="setLabel('selectReferralSourcePlaceholderLabel')">
                                                    </p-dropdown>
                                                </div>

                                                <div *ngIf="member?.referralSource === 'Other'" class="p-g-12" style="margin-top: 10px">
                                                    <div class="p-inputgroup">
                                                        <span class="p-inputgroup-addon">
                                                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                        </span>
                                                        <input pInputText autocomplete="off"  maxlength="300" type="text" name="otherReferralSource"
                                                            [(ngModel)]="member.referralOther" #otherReferral="ngModel"
                                                            [placeholder]="setLabel('otherReferralLabel')" />
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- <h3 class="first">

                                                {{setLabel("covid-19?Label")}}
                                            </h3>
                                            <div class="covid-Radio p-g-12">
                                                <div class="p-g-6">
                                                    <p-radioButton name="question1" [value]='setLabel("yESValueLabel")'
                                                        [label]='setLabel("yesLabel")' [(ngModel)]="member.question1"
                                                        inputId="opt1">
                                                    </p-radioButton>
                                                </div>
                                                <div class="p-g-6">
                                                    <p-radioButton name="question1" [value]='setLabel("nOValueLabel")'
                                                        [label]='setLabel("noLabel")' [(ngModel)]="
                                                            member.question1
                                                        " inputId="opt2">
                                                    </p-radioButton>
                                                </div>
                                            </div> -->
                                        </div>

                                    </div>


                                    </div>

                                    <div class="p-g-6 memberContentForm" style="text-align: left">
                                        <h3 class="first">{{setLabel("accessControlTerminal(ACT)Label")}}</h3>
                                        <!-- <div class="p-g-12">
                                            <p-inputSwitch name="Is_Delivery_Enabled" [(ngModel)]="member.isLocked"
                                                (onChange)="
                                                    handleSwitchChange()
                                                ">
                                            </p-inputSwitch>
                                        </div> -->

                                        <div *ngIf="member.isLocked" class="package-icon" style="margin-left: 32px">
                                            <img src="assets/layout/images/red-finger-print.png"
                                                [pTooltip]='setLabel("memberIsLockedTooltipLabel")'
                                                tooltipPosition="top" style="height: 45px;">
                                        </div>
                                        <div *ngIf="!member.isLocked" class="package-icon" style="margin-left: 32px">
                                            <img src="assets/layout/images/green-finger-print.png"
                                                [pTooltip]='setLabel("memberIsUnockedTooltipLabel")'
                                                tooltipPosition="top" style="height: 45px;">
                                        </div>
                                            <div>
                                                <h3 class="first">{{setLabel("joiningDateLabel")}}</h3>
                                            </div>

                                            <div *ngIf=" !memeberSetting" class="p-g-12">
                                                <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                                    [monthNavigator]="true" [(ngModel)]="member.joiningDate"
                                                    [Placeholder]='setLabel("joiningDateLabel")' name="joinDate"
                                                    [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                                                </p-calendar>
                                            </div>
                                            <div *ngIf=" memeberSetting" class="p-g-12">
                                                <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                                    [monthNavigator]="true" [(ngModel)]="member.joiningDate"
                                                    [Placeholder]='setLabel("joiningDateLabel")' [disabled]="true"
                                                    name="joinDate" [inline]="false" dateFormat="dd/mm/yy"
                                                    [showIcon]="true">
                                                </p-calendar>
                                            </div>

                                            <div *ngIf="branchSessionStorage == '67728682419e66d9220356ec'">
                                                <h3 class="first">{{setLabel("dateOfBirthLabel")}}<span
                                                        style="color: red; margin-left: 5px;">*</span></h3>
                                            </div>
                                            <div *ngIf="branchSessionStorage !== '67728682419e66d9220356ec'">
                                                <h3 class="first">{{setLabel("dateOfBirthLabel")}}</h3>
                                            </div>
                                            <div *ngIf="branchSessionStorage == '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <p-calendar required [yearNavigator]="true" yearRange="1950:2040"
                                                    [monthNavigator]="true" [(ngModel)]="member.dateOfBirth"
                                                    [placeholder]='setLabel("dateOfBirthPlaceholderLabel")'
                                                    name="dateOfBirth" [inline]="false" dateFormat="dd/mm/yy"
                                                    [showIcon]="true" (ngModelChange)="checkDateOfBirth()"
                                                    #dob="ngModel">
                                                </p-calendar>
                                                <div class="errorShow">
                                                    <small *ngIf="dob.errors?.['required']">
                                                        {{ setLabel('dobRequiredErrorLabel') }}
                                                    </small>
                                                </div>
                                            </div>
                                            <div *ngIf="branchSessionStorage !== '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                                    [monthNavigator]="true" [(ngModel)]="
                                                        member.dateOfBirth
                                                    " [placeholder]='setLabel("dateOfBirthPlaceholderLabel")'
                                                    name="dateOfBirth" [inline]="false" dateFormat="dd/mm/yy"
                                                    [showIcon]="true" (ngModelChange)="checkDateOfBirth()">
                                                </p-calendar>
                                            </div>
                                            <div *ngIf="dateOfBirthError" class="errorShow">
                                                {{setLabel("dateOfBirthErrorLabel")}}
                                            </div>

                                            <div class="p-g-12">
                                                <h3 class="first">{{setLabel("identityTypeLabel")}}</h3>
                                                <div style="display: flex; gap: 3rem;" class="p-g-12">
                                                    <p-radioButton (click)="onIdentityTypeChange()" name="identityType"
                                                        [value]="'CNIC'" [(ngModel)]="selectedIdentityType"
                                                        label="{{setLabel('cNICLabel')}}"></p-radioButton>

                                                    <p-radioButton (click)="onIdentityTypeChange()" name="identityType"
                                                        [value]="'Passport'" [(ngModel)]="selectedIdentityType"
                                                        label="{{setLabel('passportLabel')}}"></p-radioButton>
                                                </div>
                                            </div>
                                            <div *ngIf="selectedIdentityType === 'CNIC' && branchSessionStorage == '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <h3 class="first"> {{setLabel("cNICLabel")}}<span
                                                        style="color: red; margin-left: 5px;">*</span></h3>
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card"
                                                            aria-hidden="true"></i></span>
                                                    <input required type="text" autocomplete="off" pInputText
                                                        #CNIC="ngModel" minlength="13" maxlength="13"
                                                        pattern="[A-Za-z0-9]+"
                                                        [placeholder]="member.CNIC ? '' : setLabel('cNICLabel')"
                                                        name="CNIC" [(ngModel)]="member.CNIC"
                                                        (ngModelChange)="onCNICChange()" />
                                                </div>
                                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"
                                                    class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.minlength">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                                </div>
                                                <div class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.['required']">{{setLabel("cNIC13DigitsRequiredErrorLabel")}}</small>
                                                </div>
                                                <div *ngIf="errorMessage">
                                                    <div style="color: red;margin-left: 3rem; font-size: small;">
                                                        {{errorMessage}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div *ngIf="selectedIdentityType === 'CNIC'&& branchSessionStorage !== '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <h3 class="first"> {{setLabel("cNICLabel")}}</h3>
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" autocomplete="off" pInputText #CNIC="ngModel"
                                                        minlength="13" maxlength="13" pattern="[A-Za-z0-9]+"
                                                        [placeholder]="member.CNIC ? '' : setLabel('cNICLabel')"
                                                        name="CNIC" [(ngModel)]="member.CNIC"
                                                        (ngModelChange)="onCNICChange()" />
                                                </div>
                                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"
                                                    class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.minlength">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                                </div>
                                                <div class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.['required']">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                                </div>
                                                <div *ngIf="errorMessage">
                                                    <div style="color: red;margin-left: 3rem; font-size: small;">
                                                        {{errorMessage}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="selectedIdentityType === 'Passport' && branchSessionStorage == '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <h3 class="first"> {{setLabel("passportLabel")}}<span
                                                        style="color: red; margin-left: 5px;">*</span></h3>
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card"
                                                            aria-hidden="true"></i></span>
                                                    <input required type="text" autocomplete="off" pInputText
                                                        #CNIC="ngModel" minlength="9" maxlength="9"
                                                        pattern="[A-Za-z0-9]+"
                                                        [placeholder]="member.CNIC ? '' : setLabel('passportLabel')"
                                                        name="CNIC" [(ngModel)]="member.CNIC"
                                                        (ngModelChange)="onCNICChange()" />
                                                </div>
                                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"
                                                    class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.minlength">{{setLabel("passport8DigitsErrorLabel")}}</small>
                                                </div>
                                                <div class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.['required']">{{setLabel("cNIC13DigitsErrorLabel")}}</small>
                                                </div>
                                                <div *ngIf="errorMessage">
                                                    <div style="color: red;margin-left: 3rem; font-size: small;">
                                                        {{errorMessage}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="selectedIdentityType === 'Passport' && branchSessionStorage !== '67728682419e66d9220356ec'"
                                                class="p-g-12">
                                                <h3 class="first"> {{setLabel("passportLabel")}}</h3>
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-id-card"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" autocomplete="off" pInputText #CNIC="ngModel"
                                                        minlength="9" maxlength="9" pattern="[A-Za-z0-9]+"
                                                        [placeholder]="member.CNIC ? '' : setLabel('passportLabel')"
                                                        name="CNIC" [(ngModel)]="member.CNIC"
                                                        (ngModelChange)="onCNICChange()" />
                                                </div>
                                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.touched)"
                                                    class="errorShow">
                                                    <small
                                                        *ngIf="CNIC.errors?.minlength">{{setLabel("passport8DigitsErrorLabel")}}</small>
                                                </div>
                                                <div *ngIf="errorMessage">
                                                    <div style="color: red;margin-left: 3rem; font-size: small;">
                                                        {{errorMessage}}

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <h3 class="first">{{setLabel("monthlyFeeLabel")}}</h3> -->
                                            <!-- <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-money"
                                                            aria-hidden="true"></i></span>
                                                    <input type="number" pattern="[0-9]+" autocomplete="off" [ngClass]="
                                                            monthNumber.invalid &&
                                                            (monthNumber.dirty ||
                                                                monthNumber.touched)
                                                                ? 'errorInput'
                                                                : ''
                                                        " required #monthNumber="ngModel"
                                                        [Placeholder]='setLabel("monthlyFeePKR")' pInputText
                                                        name="monthNumber" [(ngModel)]="
                                                            member.monthFee
                                                        " />
                                                </div>
                                                <div *ngIf="
                                                        monthNumber.invalid &&
                                                        (monthNumber.dirty ||
                                                            monthNumber.touched)
                                                    ">
                                                    <div *ngIf="
                                                            monthNumber.errors
                                                                .required
                                                        " class="errorShow">
                                                        {{setLabel("enterMonthlyFeeLabel")}}
                                                    </div>
                                                    <div *ngIf="
                                                            monthNumber.errors
                                                                .pattern
                                                        " class="errorShow">
                                                        {{setLabel("enterMonthlyFeeLabel")}}
                                                    </div>
                                                </div>
                                            </div> -->

                                            <!-- <h3 class="first">Profession</h3>
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-user-md" aria-hidden="true"></i></span>
                                            <input type="text" pattern="[A-Za-z ]+" pInputText #profession="ngModel" placeholder="Profession"
                                                autocomplete="off" name="profession" [(ngModel)]="member.profession">
                                            </div>
                                        </div> -->

                                            <!-- <div class="p-g-12">
                                                <div class="p-g"></div>
                                            </div> -->
                                            <!-- <h3 class="first">
                                                {{setLabel("registrationFeeLabel")}}
                                            </h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-money"
                                                            aria-hidden="true"></i></span>
                                                    <input type="number" required #registerNumber="ngModel"
                                                        pattern="[0-9]+" autocomplete="off" [ngClass]="
                                                            registerNumber.invalid &&
                                                            (registerNumber.dirty ||
                                                                registerNumber.touched)
                                                                ? 'errorInput'
                                                                : ''
                                                        " [Placeholder]='setLabel("registrationFeePKR")' pInputText
                                                        name="registerNumber" [(ngModel)]="
                                                            member.registerationFee
                                                        " />
                                                </div>
                                                <div *ngIf="
                                                        registerNumber.invalid &&
                                                        (registerNumber.dirty ||
                                                            registerNumber.touched)
                                                    ">
                                                    <div *ngIf="
                                                            registerNumber
                                                                .errors.required
                                                        " class="errorShow">
                                                        {{setLabel("registrationFeerequiredLabel")}}
                                                    </div>
                                                    <div *ngIf="
                                                            registerNumber
                                                                .errors.pattern
                                                        " class="errorShow">
                                                        {{setLabel("numbersallowedLabel")}}
                                                    </div>
                                                </div>
                                            </div> -->

                                            <h3 class="first">
                                                {{setLabel("emergencyContactNameLabel")}}
                                            </h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-user"
                                                            aria-hidden="true"></i></span>
                                                    <input maxlength="100" autocomplete="off" id="emergencyName"
                                                        pattern="[A-Za-z ]+" type="text" autofocus pInputText
                                                        [placeholder]="member.emergencyContact.name ? '' : setLabel('emergencyContactNameLabel')"
                                                        #emergencyName="ngModel" name="emergencyName"
                                                        [(ngModel)]="member.emergencyContact.name" />
                                                </div>
                                                <div
                                                    *ngIf="emergencyName.invalid && (emergencyName.dirty || emergencyName.touched)">
                                                    <div *ngIf="emergencyName.errors.pattern" class="errorShow">
                                                        {{setLabel("nameonlylettersLabel")}}
                                                    </div>
                                                </div>
                                            </div>
                                            <h3 class="first">
                                                {{ setLabel("emergencyContactMobileLabel") }}
                                            </h3>
                                            <div class="p-g-12">
                                                <app-phone-input [placeholder]="setLabel('emergencyContactMobileLabel')"
                                                    [(phoneNumber)]="member.emergencyContact.contact"
                                                    [initialCountry]="'PK'" [required]="false"
                                                    (validNumber)="formattedNumber = $event"
                                                    (formattedForSaving)="member.emergencyContact.contact = $event"
                                                    style="max-width: 600px; margin: auto; align-items: center;">
                                                </app-phone-input>
                                            </div>



                                            <!-- <h3 class="first">Card Details</h3>
                          <div class="p-g-12">
                            <div class="p-inputgroup">
                              <span class="p-inputgroup-addon"><i class="fa fa-user-md" aria-hidden="true"></i></span>
                              <input type="text" pInputText #CardNo="ngModel" placeholder="Card Number" autocomplete="off"
                                name="CardNo" [(ngModel)]="member.cardNo">
                            </div>
                          </div> -->

                                            <h3 class="first">{{setLabel("addressLabel")}}</h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-location-arrow"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" autocomplete="off" pInputText
                                                        [placeholder]="member.contactDetail.address.street ? '' : setLabel('streetPlaceholderLabel')"
                                                        name="street"
                                                        [(ngModel)]="member.contactDetail.address.street" />
                                                </div>
                                            </div>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" autocomplete="off" pInputText
                                                        [placeholder]="member.contactDetail.address.city ? '' : setLabel('cityPlaceholderLabel')"
                                                        name="city" [(ngModel)]="member.contactDetail.address.city" />
                                                </div>
                                            </div>
                                            <!-- <div class="p-g-12">
                            <div class="p-inputgroup">
                              <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                              <input type="text" autocomplete="off" pInputText placeholder="State" name="state"
                                [(ngModel)]="member.contactDetail.address.state">
                            </div>
                          </div> -->
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon"><i class="fa fa-map-marker"
                                                            aria-hidden="true"></i></span>
                                                    <input type="text" autocomplete="off" pInputText
                                                        [placeholder]="member.contactDetail.address.country ? '' : setLabel('countryPlaceholderLabel')"
                                                        name="country"
                                                        [(ngModel)]="member.contactDetail.address.country" />
                                                </div>
                                            </div>

                                            <!-- <div class="p-g-12">
                            <div class="p-g">
                              <h3 class="first">Have you Been to GYM before ?</h3>
                              <div class="p-g-12">
                                <div class="p-g-6">
                                  <p-radioButton name="question1" value="YES" label="YES" [(ngModel)]="member.question1"
                                    inputId="opt1">
                                  </p-radioButton>
                                </div>
                                <div class="p-g-6">
                                  <p-radioButton name="question1" value="NO" label="NO" [(ngModel)]="member.question1"
                                    inputId="opt2">
                                  </p-radioButton>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="p-g-12">
                            <div class="p-g">
                              <h3 class="first">Do You Have Any Type Of Illness ?</h3>
                              <div class="p-g-12">
                                <div class="p-g-6">
                                  <p-radioButton name="question2" value="YES" label="YES" [(ngModel)]="member.question2"
                                    inputId="opt3">
                                  </p-radioButton>
                                </div>
                                <div class="p-g-6">
                                  <p-radioButton name="question2" value="NO" label="NO" [(ngModel)]="member.question2"
                                    inputId="opt4">
                                  </p-radioButton>
                                </div>
                              </div>
                            </div>
                            <div class="p-g" *ngIf="member.question2 == 'YES'">
                              <h3 class="first">Type Of Illness?</h3>
                              <div class="p-g-12">
                                <div class="p-inputgroup">
                                  <span class="p-inputgroup-addon"><i class="fa fa-hospital-o" aria-hidden="true"></i></span>
                                  <input type="text" autocomplete="off" required pInputText placeholder="Type Of Illness"
                                    name="medicalDetail" [(ngModel)]="member.emergencyContact.medicalDetail">
                                </div>
                              </div>
                            </div>
                          </div> -->
                                            <h3 class="first">{{ setLabel("packageNameLabel") }} <span
                                                    style="color: red">*</span></h3>
                                            <div class="p-g-12">
                                                <div class="p-inputgroup">
                                                    <span class="p-inputgroup-addon">
                                                        <i class="fa fa-money" aria-hidden="true"></i>
                                                    </span>
                                                    <input [readOnly]="true" autocomplete="off" pInputText
                                                        name="packageName" [(ngModel)]="member.packageName">
                                                    <button type="button" (click)="showPackageDialog()" pButton
                                                        [label]='setLabel("changePackageLabel")'
                                                        style="width: -webkit-fill-available;margin-left: 10px;"></button>
                                                </div>
                                                <div *ngIf="!member.packageName || member.packageName === 'Select Package'" class="errorShow"
                                                    style="text-align: center; margin-top: 8px;">
                                                    {{setLabel("selectPackageErrorLabel")}}
                                                </div>
                                            </div>
                                            <!-- Dialog for selecting packages -->
                                            <p-dialog [header]='setLabel("selectPackageHeaderLabel")'
                                                [(visible)]="isPackageDialogVisible" [modal]="true" [responsive]="true"
                                                [width]="'60%'">
                                                <div>
                                                    <p-dropdown [options]="packagesDropDown" name="changePackageName"
                                                        [(ngModel)]="member.packageId" [style]="{ width: '100%' }">
                                                    </p-dropdown>
                                                </div>
                                                <p *ngIf="isInvalidPackage()" class="errorShow"

                                                > {{setLabel("selectPackageErrorLabel")}}</p>
                                                <p-footer class="dialog-footer">
                                                    <button type="button" (click)="isPackageDialogVisible = false"
                                                        pButton [label]='setLabel("cancelLabel")'
                                                        class="p-button-secondary"></button>
                                                    <button type="button" (click)="updatePackage()" pButton
                                                        [label]='setLabel("updatePackageLabel")'
                                                        [disabled]="isInvalidPackage()"
                                                         [ngStyle]="{
                                                                     opacity: isInvalidPackage() ? 0.4 : 1,
                                                                     cursor: isInvalidPackage() ? 'not-allowed' : 'pointer'}"></button>
                                                </p-footer>
                                            </p-dialog>

                                            <div class="p-g-12 sp-block" *ngIf="member._id">
                                                <h3 class="first sp-heading">
                                                    {{ setLabel("secondaryPackagesLabel") }}
                                                    <span class="sp-count-badge" *ngIf="assignedSecondaryPackages.length">
                                                        {{ assignedSecondaryPackages.length }}
                                                    </span>
                                                </h3>
                                                <p class="sp-hint">{{ setLabel("secondaryPackagesHintLabel") }}</p>
                                                <div class="sp-chip-row" *ngIf="assignedSecondaryPackages.length">
                                                    <span class="sp-chip" *ngFor="let pkg of assignedSecondaryPackages">
                                                        <span class="sp-chip-name" [title]="pkg.packageName">{{ pkg.packageName }}</span>
                                                        <span class="sp-chip-fee" *ngIf="secondaryPackageFeeAmount(pkg) != null">
                                                            {{ secondaryPackageFeeAmount(pkg) | number:'1.0-0' }}
                                                        </span>
                                                        <button type="button" class="sp-chip-remove"
                                                            (click)="removeSecondaryPackage(pkg)"
                                                            [disabled]="secondaryPackageSaving"
                                                            [pTooltip]="setLabel('removeSecondaryPackageLabel')"
                                                            tooltipPosition="top">
                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                                <div class="p-inputgroup sp-add-row" *ngIf="secondaryPackageAssignOptions.length">
                                                    <span class="p-inputgroup-addon">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </span>
                                                    <p-dropdown [options]="secondaryPackageAssignOptions"
                                                        [(ngModel)]="selectedSecondaryToAdd"
                                                        [ngModelOptions]="{standalone: true}"
                                                        [placeholder]="setLabel('addSecondaryPackagePlaceholderLabel')"
                                                        [style]="{ width: '100%' }"
                                                        [filter]="true"
                                                        appendTo="body"
                                                        [disabled]="secondaryPackageSaving"></p-dropdown>
                                                    <button type="button" pButton
                                                        [label]="setLabel('addSecondaryPackageBtnLabel')"
                                                        [disabled]="!selectedSecondaryToAdd || secondaryPackageSaving"
                                                        (click)="assignSecondaryPackage()"></button>
                                                </div>
                                                <p class="sp-empty" *ngIf="!assignedSecondaryPackages.length && !secondaryPackageAssignOptions.length">
                                                    {{ setLabel("noSecondaryPackagesAvailableLabel") }}
                                                </p>
                                            </div>


                                            <!-- <p-dropdown [options]="statusOptions" name="status" required
                                                [(ngModel)]="seletedStatus" (onChange)="refreshFeeDetails()"
                                                class="feeDropdown"></p-dropdown> -->
                                            </div>
                                </form>
                            </div>
                            <div style="clear: both"></div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel [header]='setLabel("feeDetailsLabel")'>
                        <div class="card card-w-title mobile-padding-0 add-member-res-tab-Fee-Details">
                            <div class="p-g">


                                <!-- <div class="feeDetailsHeader">
                                    <div class="p-g-3" style="text-align: center; ">
                                        <p class="memberTagText"> Due Day</p>
                                    </div>
                                    <div class="p-g-1 memberNumber">
                                        <div><b>{{member.settings.dueDate | date: 'dd'}}<sup>{{ getNthTypeDay(member.settings.dueDate | date: 'dd') }}</sup></b></div>
                                    </div>
                                    <div class="p-g-1" style="text-align: center;">
                                        <p class="memberTagText">Trainer Due Day</p>
                                    </div>
                                    <div class="p-g-3 NameInput namefieldInline">
                                        <div><b>{{member.customerstrainer.dueDate | date: 'dd'}}<sup>{{ getNthTypeDay(member.customerstrainer.dueDate | date: 'dd') }}</sup></b></div>
                                    </div>
                                </div> -->

                                <div class="p-g-12 feeDetailsStyle">
                                    <div class="fee-details-table-scroll">
                                    <p-table [value]="customerFees" [paginator]="true" [rows]="10" [loading]="loading"
                                        class="feeTable hideTabileHeadOnMobile p-table-tecfolk-fix fee-table-compact">
                                        <ng-template pTemplate="caption" style="text-align: left;">
                                            <button style="
                                            background: #3f51b5; color: white;"
                                                class="p-button p-widget p-state-default p-corner-all"><span
                                                    class="p-button-text p-c" (click)="payFee()"
                                                    *ngIf="mode == 'edit'"><i class="fa fa-plus"
                                                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("addFeeBtnLabel")}}</span></button>&nbsp;&nbsp;

                                            <button style="
                                                    background: #008cba;
                                                    color: white;
                                                " [disabled]="!(customerFees && customerFees.length > 0)
                                                " class="p-button p-widget p-state-default p-corner-all">
                                                <span class="p-button-text p-c" (click)="printAllInvoice()"><i
                                                        class="fa fa-print"
                                                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("printAllBtnLabel")}}</span></button>&nbsp;&nbsp;



                                            <!-- <button pButton type="button" (click)="printAllInvoice()" label="Print All"
                                                icon="pi pi-print" class="p-button-info"></button>&nbsp;&nbsp; -->

                                            <!-- <button id="sendReceiptButton" [disabled]="
                                                    !(
                                                        customerFees &&
                                                        customerFees
                                                            .length > 0
                                                    )
                                                " style="
                                                    background: #4caf50;
                                                    color: white;
                                                " (click)="
                                                    openAllReceiptEmailConfirmation()
                                                "
                                                class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                                                <i class="fa fa-at"
                                                    aria-hidden="true"></i>&nbsp;{{setLabel("sendReceiptBtnLabel")}}</button>&nbsp;&nbsp; -->

                                            <p-dropdown [options]="statusOptions" name="status" required
                                                [(ngModel)]="seletedStatus" (onChange)="refreshFeeDetails()"
                                                class="feeDropdown"></p-dropdown>
                                        </ng-template>

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="fee-invoice-col">{{setLabel("invoiceLabel")}}</th>
                                                <th class="fee-amount-col">{{setLabel("feeLabel")}}</th>
                                              <th class="fee-discount-col" *ngIf="feeTotal > 0 && feeTotalDiscount > 0">{{setLabel("discountLabel")}}</th>
                                                <th class="fee-tax-col" *ngIf="!hideTaxInfo">{{setLabel("taxLabel")}}</th>
                                                <th class="fee-billing-period-col">{{setLabel("billingPeriodLabel")}}</th>
                                                <th class="fee-mode-col">{{setLabel("modeLabel")}}</th>
                                                <th class="fee-type-col">{{setLabel("feeTypeLabel")}}</th>
                                                <th class="fee-invoice-date-col">{{setLabel("invoiceDateLabel")}}</th>
                                                <th class="fee-actions-col" style="text-align: center">
                                                    {{setLabel("actionsLabel")}}
                                                </th>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="body" let-fee>
                                            <tr>
                                                <td class="TrainingAttendencelabelRow fee-invoice-col">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("invoiceLabel")}}</span>
                                                    <span class="fee-invoice-with-split">
                                                        <span>{{ fee.invoice}}</span>
                                                        <span *ngIf="getFeeSplitPartLabel(fee) as splitLabel"
                                                            class="fee-split-chip"
                                                            [pTooltip]="setLabel('splitPartTooltipLabel')"
                                                            tooltipPosition="top">{{ splitLabel }}</span>
                                                        <span *ngIf="isPartialFee(fee)"
                                                            class="fee-split-chip"
                                                            [pTooltip]="getPartialFeeTooltip(fee)"
                                                            tooltipPosition="top">{{ setLabel('partialFeeChipLabel') }}</span>
                                                    </span>
                                                </td>
                                                <td class="TrainingAttendencelabelRow fee-amount-col">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("feeLabel")}}</span>
                                                    <span>{{ fee.pay | number: '1.0-0' }}</span>
                                                </td>
                                             <td class="TrainingAttendencelabelRow fee-discount-col" *ngIf="feeTotalDiscount > 0">
    <span class="TrainingAttendencelabel">{{setLabel("discountLabel")}}</span>
    <span>{{ (fee.discount !== undefined ? fee.discount : 0) | number: '1.0-0' }}</span>
</td>
                                                <td class="TrainingAttendencelabelRow fee-tax-col" *ngIf="!hideTaxInfo">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("taxLabel")}}</span>
                                                    <span>{{ (fee.tax !== undefined ? fee.tax : 0) | number: '1.0-0'
                                                        }}</span>
                                                </td>
                                                <td class="TrainingAttendencelabelRow fee-billing-period-cell">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("billingPeriodLabel")}}</span>
                                                    <span class="fee-billing-period-value">{{ formatFeeBillingPeriod(fee) }}</span>
                                                </td>

                                                <td class="TrainingAttendencelabelRow fee-mode-cell">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("modeLabel")}}</span>
                                                    <div *ngIf="!fee.paymentMode"
                                                        style="display: flex; align-items: center; margin-top: 15px; justify-content: left;">
                                                        {{setLabel("cashLabel")}}
                                                    </div>
                                                    <div class="req-photo">
                                                        <img *ngIf="showImage" [src]="imageSrc">
                                                        <button *ngIf="showImage" (click)="closeImageOverlay()"
                                                            class="close-button">{{setLabel("closeLabel")}}</button>
                                                    </div>
                                                    <div
                                                        style="display: flex; align-items: center; justify-content: left;">
                                                        <a style="padding-right: 5px;"
                                                            *ngIf="fee.paymentMode && fee.paymentMode.includes('Online-') || fee.paymentMode && fee.paymentMode.includes('Check-')"
                                                            (click)="openPhoto(fee.feeReceiptImageUrl)">
                                                            <i class="fa fa-paperclip fa-lg"
                                                                [pTooltip]='setLabel("onlinePaymentTooltipLabel")'
                                                                tooltipPosition="top"
                                                                style="display: flex; align-items: center; justify-content: center; padding-left: 5px;"></i>
                                                        </a>
                                                        {{ fee.paymentMode}}
                                                    </div>
                                                    <button pButton
                                                        *ngIf="canEditCollectedFeePaymentMode(fee)"
                                                        class="changePaymentModeBtn"
                                                        (click)="showChangePaymentModeDialog(fee, 'memberFee')" icon="fa fa-pencil">
                                                        <span> {{setLabel("editLabel")}} </span> </button>
                                                </td>
                                                <td class="TrainingAttendencelabelRow fee-type-col">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("feeTypeLabel")}}</span>
                                                    <span class="fee-type-with-chip">
                                                        <span>{{ getFeeTypeDisplay(fee.status) }}</span>
                                                        <span *ngIf="fee.isSecondaryPackageFee"
                                                            class="fee-split-chip"
                                                            [pTooltip]="fee.packageName || setLabel('secondaryPackageChipLabel')"
                                                            tooltipPosition="top">
                                                            {{ fee.packageName || setLabel("secondaryPackageChipLabel") }}
                                                        </span>
                                                    </span>
                                                </td>
                                                <td class="TrainingAttendencelabelRow fee-invoice-date-col"
                                                    [style.backgroundColor]="getInvoiceDateColor(fee)">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("invoiceDate:Label")}}</span>
                                                    <div>{{ fee.date | date : "dd/MM/yyyy, h:mm a" }}</div>
                                                    <button pButton
                                                        *ngIf="canEditInvoiceDate()"
                                                        class="changeInvoiceBtn"
                                                        (click)="showChangeInvoiceDateDialog(fee)" icon="fa fa-pencil">
                                                        <span> {{setLabel("editLabel")}} </span>
                                                    </button>
                                                </td>
                                                <!-- comments column removed — icon lives in Actions -->

                                                <td class="TrainingAttendencelabelRow fee-actions-cell">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("actionsLabel")}}</span>
                                                    <span class="fee-actions-buttons">
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("viewCommentsTooltipLabel")'
                                                            tooltipPosition="top"
                                                            class="p-button-secondary p-button fee-comment-action-btn"
                                                            icon="fa fa-comment-o"
                                                            (click)="openDialog(fee)"></button>
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("sendInvoiceDetailsTooltipLabel")'
                                                            tooltipPosition="top" class="p-button-success p-button"
                                                            icon="fa fa-whatsapp" (click)="
                                                        openWhatsApp(fee)" style="background-color: #2e8168;"></button>
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("printTooltipLabel")'
                                                            tooltipPosition="top" class="p-button-success p-button"
                                                            icon="fa fa-money" (click)="printSelected(fee)"
                                                            style="background-color: #3f51b5;"></button>
                                                        <!-- <button pButton type="button"[pTooltip]='setLabel("sendReceiptTooltipLabel")'
                                                        tooltipPosition="top" class="p-button-success p-button"
                                                        icon="fa fa-at" (click)="
                                                        openSingleReceiptEmailConfirmation(fee)" style="background: #4caf50;"></button> -->
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("deleteTooltipLabel")'
                                                            tooltipPosition="top"
                                                            *ngIf="(!memeberSetting || this.role === 'Admin') && canDeleteMemberFee(fee)"
                                                            class="p-button-danger p-button" icon="fa fa-times"
                                                            (click)="deletememberFees(fee)"></button>
                                                    </span>
                                                    <div *ngIf="showCommentDialog" class="dialog">
                                                        <div class="dialog-content">
                                                            <h2>{{setLabel("commentsLabel")}}</h2>
                                                            <div class="comment-box">
                                                                <p>{{ dialogDescription }}</p>
                                                            </div>
                                                            <button
                                                                (click)="closeDialog()">{{setLabel("closeLabel")}}</button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="footer">
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td colspan="3">
                                                    <span>
                                                        {{setLabel("feeTotalLabel")}} = {{ ( (feeTotal -
                                                        feeTotalDiscount) +
                                                        feeTotalTax )| number: '1.2-2'}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td> {{setLabel("noRecordsLabel")}}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel *ngIf="branch.gymPackage =='standard'" [header]='setLabel("trainerDetailsLabel")'>
                        <div class="card card-w-title">
                            <div class="p-g trainerDetailsRes">
                                <h3 class="first">
                                    {{setLabel("personalTrainingSession?Label")}}
                                </h3>
                                <div class="trainerRadioBtn p-g-12">
                                    <div class="p-g-2">
                                        <p-radioButton name="question3" [value]='setLabel("yESValueLabel")'
                                            [label]='setLabel("yesLabel")' [(ngModel)]="member.question3" inputId="opt5"
                                            class="p-label-active">
                                        </p-radioButton>
                                    </div>
                                    <div class="p-g-2">
                                        <p-radioButton name="question3" [value]='setLabel("nOValueLabel")'
                                            [label]='setLabel("noLabel")' class="p-label-active"
                                            [(ngModel)]="member.question3" inputId="opt6">
                                        </p-radioButton>
                                    </div>
                                </div>

                                <div class="p-g-12 p-md-6" style="text-align: left" *ngIf="member.question3 == 'YES'">
                                    <h3 *ngIf="member.customerstrainer.name" class="first">
                                        {{setLabel("dueDateTrainerFeeLabel")}}</h3>
                                    <h3 *ngIf="!member.customerstrainer.name" class="first">
                                        {{setLabel("joiningDateLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                        <div *ngIf="member.customerstrainer.name" class="p-g-12">
                                            <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="
                                                    member.customerstrainer
                                                        .dueDate
                                                " [Placeholder]='setLabel("dueDateLabel")' name="trainerDueDate"
                                                [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </div>

                                        <div *ngIf="!member.customerstrainer.name" class="p-g-12">
                                            <p-calendar disabled="true" [yearNavigator]="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="
                                                    member.customerstrainer
                                                        .dueDate
                                                " [Placeholder]='setLabel("dueDateLabel")' name="trainerDueDate"
                                                [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </div>

                                        <h3 class="first">{{setLabel("trainerFeeLabel")}}</h3>
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                                <input type="number" autocomplete="off" pattern="[0-9]+" id="trainerFee"
                                                    required #trainerFee="ngModel" pInputText
                                                    [Placeholder]='setLabel("trainerFeeLabel")' name="trainerFee"
                                                    [readOnly]="true"
                                                    [(ngModel)]="
                                                        member.customerstrainer
                                                            .totalFees
                                                    " (input)="
                                                        onChangeTrainerFee()
                                                    " [ngClass]="
                                                        trainerFee.invalid &&
                                                        (trainerFee.dirty ||
                                                            trainerFee.touched)
                                                            ? 'errorInput'
                                                            : ''
                                                    " />
                                            </div>
                                            <div *ngIf="
                                                    trainerFee.invalid &&
                                                    (trainerFee.dirty ||
                                                        trainerFee.touched)
                                                ">
                                                <div *ngIf="
                                                        trainerFee.errors
                                                            .required
                                                    " style="
                                                        color: red !important;
                                                        margin-top: 4px !important;
                                                    ">
                                                    {{setLabel("trainerFeeRequiredLabel")}}
                                                </div>
                                                <div *ngIf="
                                                        trainerFee.errors
                                                            .pattern
                                                    " style="
                                                        color: red !important;
                                                        margin-top: 4px !important;
                                                    ">
                                                    {{setLabel("trainerFeeRequiredErrorLabel")}}
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                                <div class="p-g-12 p-md-6" style="text-align: left; margin-top: -7px;"
                                    *ngIf="member.question3 == 'YES'">
                                    <h3 class="first">{{setLabel("trainerLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                                <p-dropdown [ngModelOptions]="{ standalone: true}" id="selectTrainer"
                                                    #selectTrainer="ngModel" name="selectTrainer" required
                                                    [options]="trainerOptions"
                                                    [(ngModel)]="member.customerstrainer.trainerId"
                                                    (onChange)="dropdownChange()" [style]="{ width: '100%' }"
                                                    class="dropdownFull">
                                                </p-dropdown>
                                            </div>
                                            <div *ngIf="!member.customerstrainer.trainerId" style="color: red; margin-top: 4px;">
                                                <div *ngIf="selectTrainer.errors?.required">
                                                    {{setLabel("trainerRequiredLabel")}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!-- <h3 class="first">{{setLabel("noOfSessionsBookedLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                        <div class="p-g-12">
                                            <div class="p-inputgroup">
                                                <input type="number" id="sessionCount"
                                                    [(ngModel)]="member.customerstrainer.sessionCount"
                                                    (ngModelChange)="sessionCountChange()" readonly>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <!-- <div style="width: 100%; margin-left: 126px;">
                                    <div class="p-g-4" *ngIf="member.question3 =='YES'">
                                        <span style="color: #000000 !important">Select
                                            the trainer(F4): </span>&nbsp;
                                        <p-dropdown [options]="trainerOptions" [(ngModel)]="member.customerstrainer.trainerId"
                                            (onChange)="dropdownChange()"></p-dropdown>
                                        &nbsp;&nbsp;
                                    </div>

                                    <div class="p-g-4" style="margin-left: 210px;" *ngIf="member.question3 ==
                                                                'YES'">
                                        <span style="color: #000000 !important">Trainer
                                            Fee DueDate(F9):&nbsp;
                                            <p-calendar class="claenderTrainer" [yearNavigator]="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="member.customerstrainer.dueDate"
                                                placeholder="DueDate" name="trainerDueDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </span>
                                    </div>
                                </div>

                                <div class="p-g-12" style="padding-top: 15px;">
                                    <div class="p-g-4" style="text-align: right;" *ngIf="member.question3 ==
                                                            'YES'">
                                        <span style="color: #000000 !important">Gym
                                            share:
                                            <input type="number" autocomplete="off" id="gymShare"
                                                required pInputText placeholder="Gym Share"
                                                name="gymShare" [(ngModel)]="member.customerstrainer.gymShare" /></span>
                                        &nbsp; &nbsp;&nbsp;
                                    </div>
                                    <div class="p-g-4" style="text-align: center;" *ngIf="member.question3 =='YES'">
                                        <span style="color: #000000 !important">Trainer
                                            Fee:
                                            <input type="number" autocomplete="off" id="trainerFee"
                                                required pInputText
                                                placeholder="Trainer Fee" name="totalFees"
                                                [(ngModel)]="member.customerstrainer.totalFees" /></span>&nbsp;
                                        &nbsp;&nbsp;
                                    </div>

                                    <div class="p-g-4" style="text-align: left;" *ngIf="member.question3 ==
                                                            'YES'">
                                        <span style="color: #000000 !important">Trainer
                                            share:
                                            <input type="number" autocomplete="off" id="trainerShare" required pInputText
                                                placeholder="Trainer Share" name="trainerShare" [(ngModel)]="member.customerstrainer.trainerShare" />
                                            </span>&nbsp;
                                        &nbsp;&nbsp;
                                    </div>
                                </div> -->
                            </div>
                            <!-- <div class="p-g-12">
                                <div class="p-g trainerDetailsRes">
                                    <h3 class="first">Personal Training Session ?</h3>
                                    <div class="p-g-12  radioBtn">
                                        <div class="p-g-2 trainerDetailsFeeFields">
                                            <p-radioButton name="question3" value="YES" label="YES"
                                                [(ngModel)]="member.question3" inputId="opt5">
                                            </p-radioButton>
                                        </div>
                                        <div class="p-g-2 trainerDetailsFeeFields">
                                            <p-radioButton name="question3" value="NO" label="NO" [(ngModel)]="member.question3"
                                                inputId="opt6">
                                            </p-radioButton>
                                        </div>
                                    </div>
                                    <div class="p-g-6" *ngIf="member.question3=='YES'">
                                        <span style="color: #000000 !important">Select the trainer: </span>&nbsp;
                                        <p-dropdown [options]="trainerOptions" [(ngModel)]="member.customerstrainer.trainerId"
                                            (onChange)="dropdownChange()"></p-dropdown>
                                        &nbsp;&nbsp;
                                    </div>
                                    <div class="p-g-6" *ngIf="member.question3=='YES'">
                                        <span style="color: #000000">Trainer Fee: <input style="width:75%" type="number"
                                                autocomplete="off" required pInputText placeholder="Trainer Fee"
                                                name="customerstrainer"
                                                [(ngModel)]="member.customerstrainer.totalFees"></span>&nbsp; &nbsp;&nbsp;
                                    </div>
                                    <div class="p-g-6" *ngIf="member.question3=='YES'">
                                        <span style="color: #000000 !important;" class="TrainerFeeInput"> <span
                                                class="labelTrainer">Trainer Fee Due Date: </span>
                                            <p-calendar class="claenderTrainer" [yearNavigator]="true" yearRange="1950:2040"
                                                [monthNavigator]="true" [(ngModel)]="member.customerstrainer.dueDate"
                                                placeholder="DueDate" name="trainerDueDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true">
                                            </p-calendar>
                                        </span>
                                    </div>
                                    <div class="p-g-6" *ngIf="member.question3=='YES'">
                                        <span style="color: #000000 !important;">Trainer share: <input style="width:75%"
                                                type="number" autocomplete="off" required pInputText placeholder="Trainer Share"
                                                name="customerstrainer"
                                                [(ngModel)]="member.customerstrainer.trainerShare"></span>&nbsp; &nbsp;&nbsp;
                                    </div>
                                    <div class="p-g-3" *ngIf="member.question3=='YES'">
                                        <span style="color: #000000 !important;">Gym share: <input style="width:75%"
                                                type="number" autocomplete="off" required pInputText placeholder="Gym Share"
                                                name="customerstrainer"
                                                [(ngModel)]="member.customerstrainer.gymShare"></span>&nbsp; &nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                            <div style="clear: both;"></div> -->
                        </div>
                    </p-tabPanel>
                    <p-tabPanel *ngIf="branch.gymPackage =='premium' || branch.gymPackage =='enterprise' "
                        [header]='setLabel("subscriptionsHeaderLabel")'>
                        <div *ngIf="subscribedServices.length === 0">
                            <h1>{{setLabel("noServiceSubscribedLabel")}}</h1>
                        </div>
                        <div class="p-table-tecfolk-fix" *ngIf="!subscriptionsDetailView">
                            <p-table [value]="subscribedServices" [tableStyle]="{ 'min-width': '50rem' }"
                                *ngIf="subscribedServices.length > 0">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{setLabel("nameLabel")}}</th>
                                        <th>{{setLabel("typeLabel")}}</th>
                                        <th>{{setLabel("statusLabel")}}</th>
                                        <th>{{setLabel("actionLabel")}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-subscribedService>
                                    <tr class="subscriptionTr"
                                        [ngStyle]="{'color': (subscribedService.type !== 'selfService' && getServiceStatus(subscribedService._id) === 'Expired') ? 'red' : null}">
                                        <td>
                                            <span class="onlyMobile">{{setLabel("nameLabel")}}</span>
                                            {{ subscribedService.name }}
                                        </td>
                                        <td>
                                            <span class="onlyMobile">{{setLabel("typeLabel")}}</span>
                                            {{ getSubscriptionType(subscribedService.type) }}
                                        </td>
                                        <td>
                                            <span class="onlyMobile">{{setLabel("statusLabel")}}</span>
                                            <span *ngIf="subscribedService.type === 'selfService'"> <strong>==</strong></span>
                                            <span *ngIf="subscribedService.type !== 'selfService'">
                                                {{ getServiceStatus(subscribedService._id) }}
                                            </span>
                                        </td>
                                        <td>
                                            <span class="onlyMobile">{{setLabel("actionLabel")}}</span>
                                            <button pButton class="p-button-success"
                                                (click)="showSubscriptionDetails(subscribedService)">{{setLabel("viewDetailsLabel")}}</button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div *ngIf="subscriptionsDetailView" class="subscriptionsDetailMain">
                            <div class="subscriptionsDetailHeading">
                                <h2>{{serviceInDetailView.name}}<span>{{getSubscriptionType(serviceInDetailView.type)}}</span>
                                </h2>
                                <button pButton icon="pi pi-arrow-left"
                                    (click)="closeAddSubscriptionDialog()">{{setLabel("backToListLabel")}}</button>
                            </div>
                            <div *ngIf="serviceInDetailView.type !== 'selfService'" class="subscriptionsDetailHeading">
                                <h3>{{setLabel("currentActiveSubscriptionsStatusLabel")}}</h3>
                            </div>
                            <div *ngIf="!isActiveSubscriptionAvailable && serviceInDetailView.type !== 'selfService'">
                                <h4 class="noDataMessage">{{setLabel("noActiveSubscriptionsAvailableLabel")}}</h4>
                            </div>

                            <div class="subscriptionsDetailBody" *ngIf="isActiveSubscriptionAvailable ">
                                <!-- && getSubscriptionType(serviceInDetailView.type) != 'Self Service' -->
                                <!-- <div class="subscriptionsDetailItem">
                                    <label>{{setLabel("trainerLabel")}}</label>
                                    <span>{{subscriptionDetail.trainers}}</span>
                                </div> -->
                                <div class="subscriptionsDetailItem" *ngIf="serviceInDetailView.type !== 'selfService'">
                                    <label>{{setLabel("startDateLabel")}}</label>
                                    <span>{{subscriptionDetail.startDate | date : 'mediumDate'}}</span>

                                </div>
                                <div class="subscriptionsDetailItem" *ngIf="serviceInDetailView.type !== 'selfService'">
                                    <label>{{setLabel("endDateLabel")}}</label>
                                    <span>{{subscriptionDetail.dueDate | date : 'mediumDate'}}</span>
                                </div>
                                <div class="subscriptionsDetailItem">
                                    <label>{{setLabel("totalSessionsLabel")}}</label>
                                    <span>{{subscriptionDetail.totalSessions}}</span>
                                </div>
                                <div class="subscriptionsDetailItem">
                                    <label>{{setLabel("conductedSessionsLabel")}}</label>
                                    <span>{{subscriptionDetail.totalConductedSessions}}</span>
                                </div>
                                <div class="subscriptionsDetailItem">
                                    <label>{{setLabel("absentFromSessionsLabel")}}</label>
                                    <span>{{subscriptionDetail.totalNoShowSessions}}</span>
                                </div>
                                <div class="subscriptionsDetailItem">
                                    <label>{{setLabel("remainingSessionsLabel")}}</label>
                                    <span>{{subscriptionDetail.remainingSessions}}</span>
                                </div>
                            </div>
                            <div class="subscriptionsDetailHistory">
                                <div class="subscriptionsDetailHeading">
                                    <h3>{{setLabel("subscriptionHistoryLabel")}}</h3>
                                </div>
                                <!-- Loop through each service group - Only for Month Wise or Session Wise -->
                                <ng-container *ngFor="let serviceGroup of groupedSubscriptions">
                                <div *ngIf="isMonthWiseOrSessionWise(serviceGroup)"
                                     class="serviceGroupSection" style="margin-bottom: 30px;">

                                    <!-- Service Subscriptions Table -->
                                    <div class="subscriptionsDetailTable p-table-tecfolk-fix">
                                        <p-table [value]="serviceGroup.subscriptions" [tableStyle]="{ 'min-width': '50rem' }">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>{{setLabel("nameLabel")}}</th>
                                                    <th>{{setLabel("typeLabel")}}</th>
                                                    <th>{{setLabel("statusLabel")}}</th>
                                                    <th
                                                        *ngIf="serviceGroup.type !== 'selfService'">
                                                        {{setLabel("trainerLabel")}}</th>
                                                    <th>{{setLabel("feeLabel")}}</th>
                                                    <th>{{setLabel("discountLabel")}}</th>
                                                    <th *ngIf="!hideTaxInfo">{{setLabel("taxLabel")}}</th>
                                                    <th>{{setLabel("modeLabel")}}</th>
                                                    <th>{{setLabel("invoiceDateLabel")}}</th>
                                                    <th>{{setLabel("commentLabel")}}</th>
                                                    <th>{{setLabel("actionsLabel")}}</th>
                                                </tr>
                                            </ng-template>
                                        <ng-template pTemplate="body" let-subscription>
                                            <!-- Display summary header for Month Wise subscription - Start and End Date only -->
                                            <tr *ngIf="isMonthWiseSubscription(subscription)">
                                                <td colspan="4" style="padding: 8px 0 14px 0; margin: 0; border: 0;">
                                                    <div class="p-g" style="margin: 0;">
                                                        <div class="p-g-12 p-md-6" style="padding: 0 6px 0 0;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("startDateLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.startDate | date : 'mediumDate'" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-6" style="padding: 0 0 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("endDateLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.dueDate | date : 'mediumDate'" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td [attr.colspan]="serviceGroup.type !== 'selfService' ? (hideTaxInfo ? 6 : 7) : (hideTaxInfo ? 5 : 6)"
                                                    style="padding: 8px 0 14px 0; margin: 0; border: 0; background: transparent;">
                                                </td>
                                            </tr>
                                            <!-- Display summary header for Session Wise subscription - All fields
                                                 Training services use this detailed view by default. -->
                                            <tr *ngIf="isSessionWiseSubscription(subscription)">
                                                <td [attr.colspan]="serviceGroup.type !== 'selfService' ? (hideTaxInfo ? 10 : 11) : (hideTaxInfo ? 9 : 10)" style="padding: 8px 0 14px 0; margin: 0; border: 0;">
                                                    <div class="p-g" style="margin: 0;">
                                                        <div class="p-g-12 p-md-2" style="padding: 0 6px 0 0;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("startDateLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.startDate | date : 'mediumDate'" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-2" style="padding: 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("endDateLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.dueDate | date : 'mediumDate'" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-2" style="padding: 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("totalSessionsLabel")}}</label>
                                                            <input pInputText type="text" [value]="getSubscriptionDisplayedSessionCount(subscription)" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-2" style="padding: 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("conductedSessionsLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.totalConductedSessions || 0" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-2" style="padding: 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("absentFromSessionsLabel")}}</label>
                                                            <input pInputText type="text" [value]="subscription.totalNoShowSessions || 0" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                        <div class="p-g-12 p-md-2" style="padding: 0 0 0 6px;">
                                                            <label style="display: block; font-size: 13px; color: #6c757d; margin-bottom: 4px;">{{setLabel("remainingSessionsLabel")}}</label>
                                                            <input pInputText type="text" [value]="getSubscriptionDisplayedRemainingSessions(subscription)" readonly
                                                                style="width: 100%; height: 30px; background: #e9ecef; border: 1px solid #ced4da; color: #212529;" />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                                <tr class="subscription-history-entry-row">
                                                <td *ngIf="subscription.type == 'selfService'"><span
                                                        class="onlyMobile">{{setLabel("nameLabel")}}</span>{{subscription.servicePackageNames?.join(',') || '-' }}</td>
                                                <td *ngIf="subscription.type == 'trainingService'"><span
                                                        class="onlyMobile">{{setLabel("nameLabel")}}</span>{{ subscription.name }}</td>
                                                <td><span class="onlyMobile">{{setLabel("typeLabel")}}</span>{{getSubscriptionPackageType(subscription)}}</td>
                                                <td><span class="onlyMobile">{{setLabel("statusLabel")}}</span>{{getSubscriptionStatus(subscription.dueDate) }}</td>
                                                <td
                                                    *ngIf="serviceGroup.type !== 'selfService'">
                                                    <span class="onlyMobile">{{setLabel("trainerLabel ")}}</span>{{getSubscriptionTrainer(subscription.trainerId) }}</td>
                                                <td><span class="onlyMobile">{{setLabel(" feeLabel")}}</span>{{ subscription.pay | number:
                                                    '1.0-0'}}</td>
                                                <td><span class="onlyMobile">{{setLabel("discountLabel")}}</span>{{ subscription.discount | number: '1.0-0' }}</td>
                                                <td *ngIf="!hideTaxInfo"><span
                                                        class="onlyMobile">{{setLabel("taxLabel ")}}</span>{{subscription.tax | number:'1.0-0'}}</td>
                                                <td>
                                                    <span class="onlyMobile">{{setLabel("modeLabel")}}</span>{{ getSubscriptionPaymentModeDisplay(subscription) }}
                                                    <button pButton
                                                        *ngIf="canEditCollectedFeePaymentMode(subscription)"
                                                        class="changePaymentModeBtn"
                                                        (click)="showChangePaymentModeDialog(subscription, 'subscriptionFee')"
                                                        icon="fa fa-pencil"> <span> Edit </span> </button>
                                                </td>
                                                <td>
                                                    <span class="onlyMobile">{{setLabel("invoiceDateLabel")}}</span>
                                                    <div>{{ (subscription.createdDate || subscription.date) | date : 'dd/MM/yyyy, h:mm a' }}</div>
                                                    <button pButton
                                                        *ngIf="canEditInvoiceDate()"
                                                        class="changeInvoiceBtn"
                                                        (click)="showChangeSubscriptionInvoiceDateDialog(subscription)"
                                                        icon="fa fa-pencil">
                                                        <span> {{setLabel("editLabel")}} </span>
                                                    </button>
                                                </td>
                                                <td>
                                                    <span class="onlyMobile">{{setLabel("commentsLabel")}}</span>
                                                    <div class="p-g-12 p-md-12">
                                                        <div class="p-inputgroup comment-responsive">
                                                            <span class="p-g-3 p-inputgroup-addon"
                                                                style="width: 29%; margin-left:5px;">
                                                                <i class="fa fa-comment-o comment-icon"
                                                                    aria-hidden="true"
                                                                    (click)="openSubscriptionDialog(subscription)"
                                                                    [pTooltip]='setLabel("viewCommentsTooltipLabel")'></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="showCommentDialog" class="dialog">
                                                        <div class="dialog-content">
                                                            <h2>{{setLabel("commentsLabel")}}</h2>
                                                            <div class="comment-box">
                                                                <p>{{ subscription.description }}</p>
                                                            </div>
                                                            <button
                                                                (click)="closeDialog()">{{setLabel("closeLabel")}}</button>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="onlyMobile">{{setLabel("actionLabel")}}</span>
                                                    <div class="subscriptionsDetailHistoryBtn"
     style="display: flex; align-items: center; justify-content: center; gap: 4px; flex-wrap: nowrap; white-space: nowrap;">
                                                        <button pButton type="button"
    [pTooltip]='setLabel("sendInvoiceDetailsTooltipLabel")'
    tooltipPosition="top" class="p-button-success p-button"
    icon="fa fa-whatsapp" style="background-color: #2e8168;"
    (click)="getSingleSubscriptionFeeWhatsapp(subscription._id, subscription.dueDate)">
</button>
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("printTooltipLabel")'
                                                            tooltipPosition="top" class="p-button-success p-button"
                                                            icon="fa fa-money" style="background-color: #3f51b5;"
                                                            (click)="getSingleSubscriptionFeePrint(subscription._id, subscription.startDate, subscription.dueDate, subscription.type)"></button>
                                                        <button pButton type="button"
                                                            [pTooltip]='setLabel("sendReceiptTooltipLabel")'
                                                            tooltipPosition="top" class="p-button-success p-button"
                                                            icon="fa fa-at" style="background: #4caf50;"
                                                            (click)="getSingleSubscriptionFeeEmail(subscription._id, subscription.startDate, subscription.dueDate)"></button>
                                                        <button *ngIf="canDeleteSubscription()" pButton type="button" [pTooltip]='setLabel("deleteTooltipLabel")'
                                                            tooltipPosition="top" class="p-button-success p-button"
                                                            icon="fa fa-times" style="background: #F44336;"
                                                            (click)="deleteThisSubscription(subscription._id)"></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                    </div>
                                </div>
                                </ng-container>
                            </div>
                        </div>
                    </p-tabPanel>
                    <!-- <p-tabPanel header="Identity Card">
                        <div class="card card-w-title">
                            <div class="p-g">
                                <div id="ID-card" class="p-g-12">
                                    <div class="ID-card">
                                        <div class="top-row">
                                            <img class="flag" src="assets/layout/images/logo-sm.png" alt="national flag"
                                                style="width: 30px; height: 30px;">
                                            <h4 class="card-title">
                                                {{company.name}},
                                                <small>{{company.address == null ? '': company.address}}</small>
                                            </h4>
                                        </div>
                                        <div class="middle-row" style="width: 100%; text-align: left;margin-top: -33px;">
                                            <p class="name-title">Membership Number: {{member.tagNumber}}</p>
                                            <p class="name-title">Name: {{member.name}}</p>
                                            <p class="name-title">Gender: {{member.gender}}</p>
                                            <p class="name-title">Joining Date: {{member.joiningDate | date: 'dd/MM/yyyy'}}</p>
                                            <p class="name-title">Contact: {{member.contactDetail.contact}}</p>
                                        </div>
                                        <div class="ID-photo">
                                            <img style="width:100%;height:105px;margin-top:25px;"
                                                [src]="member.profile == null ? 'assets/layout/images/avatarImg.png' : member.profile" />
                                        </div>
                                        <h5 class="series-number">V {{member._id}}</h5>
                                        <h5 class="signature-title">Holder's Signature</h5>
                                    </div>
                                    <br />
                                    <div class="ID-card">
                                        <div class="top-row" style="padding: 30px 0 !important;">
                                            <img class="flag"
                                                [src]="company.bannerImage == null ? 'assets/layout/images/tec-company-logo.png' : config.Server + company.bannerImage"
                                                alt="Company Logo" style="margin-left: 35% !important; height: 60px;">
                                        </div>
                                        <div class="middle-row" style="width: 100%; text-align: left;margin-top: -20px;">
                                            <h4 class="card-title" style="text-align: center !important;">
                                                Cell: {{company.phone}}<br />
                                                {{company.address == null ? '': company.address}}</h4>
                                        </div>
                                        <div class="logoDiv" style="text-align: center;">
                                            Powered by &nbsp; <a href="http://tecfolk.com/" target="_blank"><img
                                                    style="width:66px;"
                                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png"
                                                    alt=""></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-g-12">
                                    <div class="p-g-4"></div>
                                    <div class="p-g-4" style="text-align: center;">
                                        <button class="p-button p-widget p-state-default p-corner-all" (click)="print()">
                                            <span class="p-button-text p-c">Print</span>
                                        </button>
                                    </div>
                                    <div class="p-g-4"></div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    -->

                    <p-tabPanel
                        *ngIf="mode === 'edit' && member?._id && isTrainerModuleEnabled"
                        headerStyleClass="book-trainer-tab"
                        [header]="setLabel('bookTrainerTabLabel')"
                    >
                        <app-book-trainer
                            *ngIf="bookTrainerTabOpened"
                            [memberId]="member._id"
                            [branchId]="user.branch"
                            [memberName]="member.name"
                            [memberTag]="member.tagNumber"
                        ></app-book-trainer>
                    </p-tabPanel>

                    <p-tabPanel *ngIf="!hideMemberSettingFromOp" [header]='setLabel("memberSettingsLabel")'>
                        <div class="card card-w-title">
                            <div class="p-g">
                                <div class="p-g-12 p-md-4">
                                    <h3>{{setLabel("nextDueDateMonthlyFeeLabel")}}</h3>
                                    <p-calendar class="nextDueDate" [yearNavigator]="true" yearRange="1950:2040"
                                        [monthNavigator]="true" [(ngModel)]="member.settings.dueDate"
                                        [Placeholder]='setLabel("dueDateLabel")' name="dueDate" [inline]="false"
                                        dateFormat="dd/mm/yy" [showIcon]="true"
                                        [minDate]="minManualDueDate"
                                        (ngModelChange)="onDueDateChange($event)"></p-calendar>
                                    <div *ngIf="dueDateBillingError" class="errorShow">
                                        {{ dueDateBillingError }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="member-access-qr" style="display:none">
                            <button
                                pButton
                                type="button"
                                label="Generate QR"
                                icon="fa fa-qrcode"
                                [disabled]="memberAccessQrLoading"
                                (click)="generateMemberAccessQr()"
                            ></button>
                            <p *ngIf="memberAccessQrStatus" style="margin-top:8px;">{{ memberAccessQrStatus }}</p>
                            <div
                                #memberAccessQrBox
                                style="margin-top:12px; background:#fff; padding:12px; display:inline-block;"
                            ></div>
                        </div>
                    </p-tabPanel>

<!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<p-tabPanel [header]="setLabel('memberAuthenticationLabel') || 'Member Authentication'">
    <div class="card card-w-title">
        <div class="p-g">
            <!-- BioMetric Card -->
            <div *ngIf="isBiometricRegistered" style="display: flex; justify-content: center;" class="p-g-12 p-md-4">
                <div class="auth-card">
                    <h3>{{setLabel("bioMetricLabel") || 'BioMetric'}}</h3>
                    <div style="text-align:center;">
                        <img src="assets/icons/fingerprint-green.png" alt="Fingerprint registered" class="auth-fingerprint-icon" />
                    </div>
                    <h3> <i class="fa fa-check"></i> {{setLabel("registeredLabel")}} </h3>
                </div>
            </div>
            <div *ngIf="!isBiometricRegistered" style="display: flex; justify-content: center;" class="p-g-12 p-md-4">
                <div class="auth-card">
                    <h3>{{setLabel("bioMetricLabel") || 'BioMetric'}}</h3>
                    <div style="text-align:center;">
                        <img src="assets/icons/fingerprint-red.png" alt="Fingerprint not registered" class="auth-fingerprint-icon" />
                    </div>
                    <h3> <i style="color: red;" class="fa fa-times"></i> {{setLabel("notRegisteredLabel")}} </h3>
                </div>
            </div>

            <!-- Face Card -->
            <div *ngIf="isFaceRegistered" style="display: flex; justify-content: center;" class="p-g-12 p-md-4">
                <div class="auth-card">
                    <h3>{{setLabel("facialLabel") || 'Face'}}</h3>
                    <div style="text-align:center;">
                        <i class="fa fa-user-circle"
                            style="font-size: 50px; color: Green; width: 5rem; height: 4rem;"></i>
                    </div>
                    <h3> <i class="fa fa-check"></i> {{setLabel("registeredLabel")}} </h3>
                </div>
            </div>
            <div *ngIf="!isFaceRegistered" style="display: flex; justify-content: center;" class="p-g-12 p-md-4">
                <div class="auth-card">
                    <h3>{{setLabel("facialLabel") || 'Face'}}</h3>
                    <div style="text-align:center;">
                        <i class="fa fa-user-circle"
                            style="font-size: 50px; color: red; width: 5rem; height: 4rem;"></i>
                    </div>
                    <h3> <i style="color: red;" class="fa fa-times"></i> {{setLabel("notRegisteredLabel")}} </h3>
                </div>
            </div>

            <div style="display: flex; justify-content: center;" class="p-g-12 p-md-4">
                <div
                    class="auth-card auth-card--portal"
                    role="button"
                    tabindex="0"
                    (click)="openWhatsAppMemberPortalInvite(member)"
                    (keydown.enter)="openWhatsAppMemberPortalInvite(member)"
                    [pTooltip]="setLabel('sendMemberPortalInvitePtooltipLabel') || 'Send member portal invite via WhatsApp'"
                    tooltipPosition="top"
                >
                    <span
                        class="auth-card-sent-badge"
                        *ngIf="memberPortalInviteSendCount > 0"
                    >
                        Sent {{ memberPortalInviteSendCount }}
                        {{ memberPortalInviteSendCount === 1 ? 'time' : 'times' }}
                    </span>
                    <h3>{{setLabel("memberPortalInviteLabel") || 'Member Portal'}}</h3>
                    <div style="text-align:center;">
                        <i class="fa fa-whatsapp auth-card-portal-icon" aria-hidden="true"></i>
                    </div>
                    <span class="auth-card-portal-action">
                        <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        {{setLabel("sendMemberPortalInviteBtnLabel") || 'WhatsApp Invite'}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</p-tabPanel>
<!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

                    <p-tabPanel *ngIf="canShowComplimentaryFreezeTab()" [header]='setLabel("complimentaryFreezeTabLabel")'>
                        <div class="card card-w-title">
                            <div class="p-g">
                                <div class="p-g-12" style="display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px;">
                                    <h3 style="margin:0;">{{ setLabel('availableComplimentaryDaysLabel') }}: {{ getAvailableComplimentaryFreezingDays() }}</h3>
                                    <button
                                        pButton
                                        type="button"
                                        [disabled]="member.isFreeze==true "
                                        [disabled]="getAvailableComplimentaryFreezingDays() <= 0"
                                        (click)="openComplimentaryFreezeRequestDialog()"
                                        class="p-button-primary"
                                        style="background-color: #4452a3; border-radius: 20px;"
                                    >{{ setLabel('newFreezeRequestBtnLabel') }}</button>

                                    <!-- <button (click)="openComplimentaryFreezeRequestDialog()" pButton type="button"
                                        [label]='setLabel("newFreezeRequestBtnLabel")' icon="pi pi-plus" class="p-button-primary"
                                        style="background-color: #4452a3">
                                    </button> -->
                                </div>

                                <div class="p-g-12">
                                    <p-table [value]="member?.freezeRequest || []" [paginator]="true" [rows]="10" class="req-management-table p-table-tecfolk-fix">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{ setLabel('complimentaryFreezeDaysHeaderLabel') }}</th>
                                                <th>{{ setLabel('complimentaryFreezeStartDateHeaderLabel') }}</th>
                                                <th>{{ setLabel('complimentaryFreezeEndDateHeaderLabel') }}</th>
                                                <th>{{ setLabel('complimentaryFreezeStatusHeaderLabel') }}</th>
                                                <th>{{ setLabel('complimentaryFreezeRequestedByHeaderLabel') }}</th>
                                                <th>{{ setLabel('actionsLabel') }}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-request>
                                            <tr>
                                                <td>{{ getFreezeRequestDayCount(request) }}</td>
                                                <td>{{ request?.startDate | date: 'dd/MM/yyyy' }}</td>
                                                <td>{{ request?.endDate | date: 'dd/MM/yyyy' }}</td>
                                                <td>{{ request?.status }}</td>
                                                <td>{{ request?.requestedBy }}</td>
                                                <td>
                                                    <button
                                                        pButton
                                                        type="button"
                                                        icon="pi pi-times"
                                                        class="p-button-danger p-button"
                                                        [ngClass]="{
                                                            'freeze-request-cancel-disabled': !canCancelComplimentaryFreezeRequest(request)
                                                        }"
                                                        [pTooltip]='setLabel("cancelRequestBtnLabel")'
                                                        [disabled]="!canCancelComplimentaryFreezeRequest(request)"
                                                        (click)="cancelComplimentaryFreezeRequest(request)"
                                                    ></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="6" style="text-align:center;">{{ setLabel('complimentaryFreezeNoDataLabel') }}</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]='setLabel("packageHistoryLabel")'>
                        <div class="card card-w-title">
                            <div class="p-g">
                                <div class="p-g-12">
                                    <p-table [value]="packageHistoryRows" [paginator]="true" [rows]="10"
                                        class="req-management-table p-table-tecfolk-fix">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{setLabel("packageNameLabel")}}</th>
                                                <th>{{setLabel("packageHistoryStartDateLabel")}}</th>
                                                <th>{{setLabel("packageHistoryEndDateLabel")}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-row>
                                            <tr>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span class="TrainingAttendencelabel">{{setLabel("packageNameLabel")}}</span>
                                                    {{ row.packageName }}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span class="TrainingAttendencelabel">{{setLabel("packageHistoryStartDateLabel")}}</span>
                                                    {{ row.startDate | date: "dd/MM/yyyy" }}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span class="TrainingAttendencelabel">{{setLabel("packageHistoryEndDateLabel")}}</span>
                                                    <ng-container *ngIf="row.endDate; else currentPackage">
                                                        {{ row.endDate | date: "dd/MM/yyyy" }}
                                                    </ng-container>
                                                    <ng-template #currentPackage>
                                                        {{ setLabel("packageHistoryCurrentLabel") }}
                                                    </ng-template>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="3" style="text-align:center;">
                                                    {{ setLabel("packageHistoryNoDataLabel") }}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]='setLabel("freezeHistoryLabel")'>
                        <div class="card card-w-title">
                            <div class="freezeHistory p-g">

                                <!-- <div class="freezehiStoryMain">
                                    <div class="freezeHistorySub">
                                        <div class="p-g-12 p-lg-6" style="
                                            text-align: center;
                                            padding-left: 5% !important;
                                        ">
                                            <p style="font-size: 20px" class="memberTagTextFreeze">
                                                Membership Number
                                            </p>
                                        </div>
                                        <div class="p-g-12 p-lg-4 memberNumberFreeze memberNumber">
                                            <input type="text" disabled pInputText [(ngModel)]="member.tagNumber" style="
                                                font-size: 40px;
                                                text-align: center;
                                            " />
                                        </div>
                                    </div>
                                    <div class="freezeHistorySub">
                                        <div class="p-g-12 p-lg-3" style="text-align: center">
                                            <p style="font-size: 20px" class="memberTagTextFreeze">
                                                Name
                                            </p>
                                        </div>

                                        <div class="p-g-12 NameInput namefieldInline">
                                            <input type="text" disabled pInputText [(ngModel)]="member.name" />
                                        </div>
                                    </div>
                                </div> -->

                                <div class="p-g-12">
                                    <p-table [value]="freezeMemberDetails" [paginator]="true" [rows]="10"
                                        [loading]="loading" class="req-management-table p-table-tecfolk-fix">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th *ngIf="branch?.permissions?.complimentaryFreezingDays">{{setLabel("totalFreezingDaysAtFreezeLabel")}}</th>
                                                <th>{{setLabel("freezeDateLabel")}}</th>
                                                <th>{{setLabel("defreezeDateLabel")}}</th>
                                                <th>{{setLabel("daysRemainingLabel")}}</th>
                                                <th>{{setLabel("statusLabel")}}</th>
                                                <th>{{setLabel("actionsLabel")}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-freezreport>
                                            <tr>
                                                <td *ngIf="branch?.permissions?.complimentaryFreezingDays" class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("totalFreezingDaysAtFreezeLabel")}}</span>{{freezreport.totalFreezingDaysAtFreeze != null ? freezreport.totalFreezingDaysAtFreeze : ''}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("freezeDateLabel")}}</span>{{freezreport.startDate|
                                                    date: "dd/MM/yyyy"}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("defreezeDateLabel")}}</span>{{freezreport.endDate|
                                                    date: "dd/MM/yyyy"}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("daysRemainingLabel")}}</span>{{freezreport.daysLeft
                                                    }}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span class="TrainingAttendencelabel">{{setLabel("statusLabel")}}
                                                    </span>{{freezreport.status }}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel">{{setLabel("actionsLabel")}}</span>
                                                    <button [pTooltip]='setLabel("cancelFreezeTooltipLabel")' pButton
                                                        type="button" *ngIf="
                                                            !memeberSetting &&
                                                            freezreport.status !==
                                                                'Cancelled' &&
                                                            freezreport.status !==
                                                                'DeFreezed'
                                                        " class="p-button-danger p-button" icon="fa fa-times" (click)="
                                                            cancelFreeze(
                                                                freezreport
                                                            )
                                                        "></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel [header]='setLabel("activityLogsLabel")'>
                        <div class="card card-w-title">
                            <div class="freezeHistory p-g">

                                <div
                                    style="width:100%; display:flex; justify-content: flex-start; align-items: center; padding: 0 10px; column-gap:50px;">
                                    <div class="calendarMain" style="display:flex; column-gap: 20px;">
                                        <div class="filterFields">
                                            <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                                            <p-calendar class="p-calendar-from" [yearNavigator]="true"
                                                yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="from"
                                                [placeholder]='setLabel("fromDatePlaceholderLabel")'
                                                [inputStyle]="{'color':'black'}" name="joinDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                                            </p-calendar>
                                        </div>
                                        <div class="filterFields">
                                            <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                                            <p-calendar class="p-calendar-to" [yearNavigator]="true"
                                                yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="to"
                                                [placeholder]='setLabel("toDatePlaceholderLabel")'
                                                [inputStyle]="{'color':'black'}" name="joinDate" [inline]="false"
                                                dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getActivityLogs()">
                                            </p-calendar>
                                        </div>
                                    </div>
                                    <div class="filterFields">
                                        <button class="fieldTitle" (click)="getActivityLogs()" pButton type="button"
                                            [label]='setLabel("getActivityBtnLabel")' class="p-button-primary"
                                            style="background-color: #3f51b5"></button>
                                    </div>
                                </div>
                                <div class="p-g-12">
                                    <p-table [value]="activityLogsResult" [paginator]="true" [rows]="10"
                                        [loading]="loading" class="req-management-table p-table-tecfolk-fix">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{setLabel("activityDateLabel")}}</th>
                                                <th>{{setLabel("activityTypeLabel")}}</th>
                                                <th>{{setLabel("activityByLabel")}}</th>
                                                <th>{{setLabel("activityScopeLabel")}}</th>
                                                <th>{{setLabel("activityOldValueLabel")}}</th>
                                                <th>{{setLabel("activityNewValueLabel")}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-requestor>
                                            <tr>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("activityDateLabel")}}</span>
                                                    {{ requestor?.createdDateNow | date: 'EEE MMM dd yyyy HH:mm:ss' }}
                                                </td>
                                                <td style="text-align: left;">
                                                    <span class="p-column-title"
                                                        class="TrainingAttendencelabel mobile-hide">
                                                        {{setLabel("activityTypeLabel")}} </span>
                                                    <span>{{requestor.activityType}},</span>
                                                    <!-- Use *ngFor to iterate over updatedValues array and display subjectType -->
                                                    <ng-container
                                                        *ngFor="let updatedValue of requestor.updatedValues; let last = last">
                                                        <!-- Check if updatedValue.subjectType is not in the excluded list -->
                                                        <ng-container
                                                            *ngIf="!isExcludedActivityType(updatedValue.subjectType)">
                                                            {{ updatedValue.subjectType }}
                                                            <!-- Add comma after each subjectType if it's not the last one -->
                                                            <span *ngIf="!last">, </span>
                                                        </ng-container>
                                                    </ng-container>

                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("activityByLabel")}}</span>{{requestor.activityBy}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("activityScopeLabel")}}
                                                    </span>{{requestor.scope}}
                                                </td>
                                                <td style="text-align: left;">
                                                    <div class="req-Lable TrainingAttendencelabel mobile-hide">
                                                        {{setLabel("oldValueLabel")}} </div>
                                                    <span class="p-column-title">{{ formatOldValues(requestor) }}</span>
                                                    <span *ngIf="requestor.activityType === 'Member Settings'"
                                                        class="p-column-title">{{requestor.oldValue |
                                                        date: 'EEE MMM dd yyyy'}}</span>
                                                    <span *ngIf="requestor.activityType === 'Update Package'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Add Fee'"
                                                        class="p-column-title">{{requestor.oldValue | date:
                                                        'EEE MMM dd yyyy'}}</span>
                                                     <span *ngIf="requestor.activityType === 'Collect Fee'"
                                                        class="p-column-title">{{requestor.oldValue | date:
                                                        'EEE MMM dd yyyy'}}</span>
                                                    <span *ngIf="requestor.activityType === 'Freeze'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'DeFreeze'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Deactivate'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Activate'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Delete Fee'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Delete Subscription Fee'"
                                                        class="p-column-title">{{requestor.oldValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Extend Freeze'"
                                                        class="p-column-title">{{requestor.oldValue}} Days</span>
                                                    <span *ngIf="requestor.activityType === 'Update Invoice Date'"
                                                        class="p-column-title">{{requestor.oldValue |date: 'EEE MMM dd yyyy HH:mm'}}</span>
                                                </td>
                                                <td style="text-align: left;">
                                                    <div class="req-Lable TrainingAttendencelabel mobile-hide">
                                                        {{setLabel("newValueLabel")}} </div>
                                                    <span class="p-column-title">{{ formatNewValues(requestor) }}</span>
                                                    <span *ngIf="requestor.activityType === 'Member Settings'" class="p-column-title">{{requestor.newValue | date: 'EEE MMM dd yyyy'}}</span>
                                                    <span *ngIf="requestor.activityType === 'Update Package'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Add Fee'" class="p-column-title">
                                                        <ng-container *ngIf="getCollectFeeDueDate(requestor) as dueDate; else collectFeeFallback">
                                                            {{ dueDate | date: 'EEE MMM dd yyyy' }}
                                                            <span *ngIf="getCollectFeeFinalAmount(requestor) as amount"> (Final Amount: {{ amount }})</span>
                                                        </ng-container>
                                                        <ng-template #collectFeeFallback>{{ requestor.newValue }}</ng-template>
                                                    </span>                                                    <span *ngIf="requestor.activityType === 'Collect Fee'" class="p-column-title">
                                                        <ng-container *ngIf="getCollectFeeDueDate(requestor) as dueDate; else collectFeeFallback">
                                                            {{ dueDate | date: 'EEE MMM dd yyyy' }}
                                                            <span *ngIf="getCollectFeeFinalAmount(requestor) as amount"> (Final Amount: {{ amount }})</span>
                                                        </ng-container>
                                                        <ng-template #collectFeeFallback>{{ requestor.newValue }}</ng-template>
                                                    </span>
                                                    <span *ngIf="requestor.activityType === 'Freeze'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'DeFreeze'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Deactivate'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Activate'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Subscription Fee'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Subscription'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Petty Cash' "class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'New Package'" class="p-column-title">{{requestor.newValue}}</span>
                                                    <span *ngIf="requestor.activityType === 'Extend Freeze'" class="p-column-title">{{requestor.newValue}} Days</span>
                                                    <span *ngIf="requestor.activityType === 'Update Invoice Date'"
                                                         class="p-column-title">{{requestor.newValue |date: 'EEE MMM dd yyyy HH:mm'}}</span>
                                                    <span *ngIf="requestor.activityType === 'Delete Fee'"
                                                         class="p-column-title">{{requestor.newValue | date: 'EEE MMM dd yyyy'}}</span>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-dialog [closeOnEscape]="true" [header]='setLabel("addBodyVitalsBtnLabel")' class="vitalDialog"
                        [(visible)]="addVitalsDialog">
                        <add-vitals [bodySpec]="selectedBodySpec"
                            (closeDialog)="closeAddBodyVitalsDialog()"></add-vitals>
                    </p-dialog>

                    <p-tabPanel *ngIf="this.branchSessionStorage === '67728682419e66d9220356ec'"
                        [header]='setLabel("memberBodyVitalsLabel")'>
                        <div class="card card-w-title">
                            <div class="p-g">
                                <div
                                    style="display: flex;justify-content: space-between;align-items: center;width: 100%;">

                                    <h3 style="font-weight: 600;">{{setLabel("memberBodyVitalsLabel")}}</h3>
                                    <button class="p-button" p-button
                                        (click)="addVitailspopup()">{{setLabel("addBodyVitalsBtnLabel") || 'Add Body Vitals '}}</button>
                                </div>
                                <!-- Update Body Specification Popup -->
                                <p-dialog [header]='setLabel("updateBodyVitalsBtnLabel")'
                                    [(visible)]="updateBodySpecDialogVisible" class="vitalDialog">
                                    <div *ngIf="showBodySpecPopup">
                                        <div class="body-spec-popup" (click)="$event.stopPropagation()">
                                            <details class="body-spec-form">
                                                <summary style="font-weight: 600;">
                                                    {{setLabel("bodyCompositionAnalysisLabel")}}</summary>
                                                <div style="display: flex; gap: 1rem;">
                                                    <div>
                                                        <label>{{setLabel("totalBodyWaterLabel") || 'Total Body Water'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.totalBodyWater"
                                                            pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("proteinLabel") || 'Protein'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.protein"
                                                            pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("mineralLabel") || 'Mineral'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.mineral"
                                                            pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("bodyFatMassLabel") || 'Body Fat Mass'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.bodyFatMass"
                                                            pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("weightLabel") || 'Weight'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.weight" pInputText />
                                                    </div>
                                                </div>
                                            </details>
                                            <details class="body-spec-form">
                                                <summary style="font-weight: 600;">
                                                    {{setLabel("muscleFatAnalysisLabel")}}</summary>
                                                <div style="display: flex; gap: 1rem;">
                                                    <div>
                                                        <label>{{setLabel("weightLabel") || 'Weight'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.weight" pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("sMMLabel") || 'SMM'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.sMM" pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("bodyFatMassLabel") || 'Body Fat Mass'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.bodyFatMass"
                                                            pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("heightLabel") || 'Body Fat Mass'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.height" pInputText />
                                                    </div>
                                                </div>
                                            </details>
                                            <details class="body-spec-form">
                                                <summary style="font-weight: 600;">{{setLabel("obesityAnalysisLabel")}}
                                                </summary>

                                                <div style="display: flex; gap: 1rem;">
                                                    <div>
                                                        <label>{{setLabel("bMILabel") || 'BMI'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.bMI" pInputText />
                                                    </div>
                                                    <div>
                                                        <label>{{setLabel("pBFLabel") || 'PBF'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.pBF" pInputText />
                                                    </div>
                                                </div>
                                            </details>
                                            <details class="body-spec-form">
                                                <summary style="font-weight: 600;">{{setLabel("waistHipRatioLabel")}}
                                                </summary>
                                                <div style="display: flex; gap: 1rem;">
                                                    <div>
                                                        <label>{{setLabel("waistHipRatioLabel") || 'Waist-HipRatio'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.waistHipRatio"
                                                            pInputText />
                                                    </div>
                                                </div>
                                            </details>
                                            <details class="body-spec-form">
                                                <summary style="font-weight: 600;">{{setLabel("visceralFatLevelLabel")}}
                                                </summary>
                                                <div style="display: flex; gap: 1rem;">
                                                    <div>
                                                        <label>{{setLabel("visceralFatLevelLabel") || 'Visceral FatLevel'}}</label>
                                                        <input type="number" [(ngModel)]="bodySpec.visceralFatLevel"
                                                            pInputText />
                                                    </div>
                                                </div>
                                            </details>
                                            <div style="margin-top: 1em; text-align: right;">
                                                <button class="p-button p-button-success" pButton
                                                    (click)="updateBodySpec(bodySpec)">{{setLabel("updateBtnLabel") ||
                                                    'Update'}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </p-dialog>

                                <div class="p-g-12">
                                    <p-table [value]="getBodySpecs" [paginator]="true" [rows]="10" [loading]="loading"
                                        class="req-management-table p-table-tecfolk-fix">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{setLabel("totalBodyWaterLabel")}} (L)</th>
                                                <th>{{setLabel("proteinLabel")}} (Kg)</th>
                                                <th>{{setLabel("mineralLabel")}} (Kg)</th>
                                                <th>{{setLabel("bodyFatMassLabel")}} (Kg)</th>
                                                <th>{{setLabel("weightLabel")}} (Kg)</th>
                                                <th>{{setLabel("heightLabel")}} (f/")</th>
                                                <th>{{setLabel("sMMLabel")}} (Kg)</th>
                                                <th>{{setLabel("bMILabel")}} (Kg)/m2</th>
                                                <th>{{setLabel("pBFLabel")}} (%)</th>
                                                <th>{{setLabel("waistHipRatioLabel")}}</th>
                                                <th>{{setLabel("visceralFatLevelLabel")}}</th>
                                                <th>{{setLabel("createdDateLabel")}}</th>
                                                <th>{{setLabel("actionLabel")}} </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-requestor>
                                            <tr>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("totalBodyWaterLabel")}}</span>{{requestor.totalBodyWater}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("proteinLabel")}}
                                                    </span>{{requestor.protein}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("mineralLabel")}}</span>{{requestor.mineral}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("bodyFatMassLabel")}}
                                                    </span>{{requestor.bodyFatMass}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("weightLabel")}}</span>{{requestor.weight}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("heightLabel")}}</span>{{requestor.height}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("sMMLabel")}}
                                                    </span>{{requestor.sMM}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("bMILabel")}}</span>{{requestor.bMI}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("pBFLabel")}}
                                                    </span>{{requestor.pBF}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("pBFLabel")}}
                                                    </span>{{requestor.waistHipRatio}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("pBFLabel")}}
                                                    </span>{{requestor.visceralFatLevel}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("createdDateLabel")}}
                                                    </span>{{requestor.createdAt | date: 'dd/MM/yyyy'}}
                                                </td>
                                                <td class="TrainingAttendencelabelRow">
                                                    <span
                                                        class="TrainingAttendencelabel mobile-hide">{{setLabel("actionLabel")}}</span>
                                                    <button [pTooltip]='setLabel("updateTooltipLabel")' pButton
                                                        type="button" class="p-button-success p-button "
                                                        (click)="openUpdateBodySpecDialog(requestor)">{{setLabel("updateBtnLabel")}}
                                                    </button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel *ngIf="isWalletAllowed" [header]='setLabel("walletAmountLabel")'>
                        <div class="card card-w-title mobile-padding-0">
                            <div class="walletTableHeader">
                                <div class="walletCurrentBalance">
                                    <label>{{setLabel("currentBalance:Label")}}</label>
                                    <label>{{walletAmount | number:'1.0-0'}}</label>
                                </div>
                                <div class="p-toolbar-tecfolk-fix">
                                    <button id="userUpdate" pButton type="button" (click)="addAmountDialog()" icon="pi pi-money-bill"
                                        class="p-button-info" [label]='setLabel("addwalletAmountLabel")'></button>
                                </div>
                            </div>
                            <div>
                                <p-table [value]="walletDetails" [loading]="loading"
                                    class="feeTable hideTabileHeadOnMobile p-table-tecfolk-fix">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{setLabel("previousWalletBalanceLabel")}}</th>
                                            <th>{{setLabel("amountAddedLabel")}}</th>
                                            <th>{{setLabel("newWalletBalanceLabel")}}</th>
                                            <th>{{setLabel("activityByLabel")}}</th>
                                            <th>{{setLabel("addedOnLabel")}}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-walletDetails>
                                        <tr class="pettyCashCurrentBalanceDetails">
                                            <td>
                                                <span class="hide-mobile">{{setLabel("previousPettyCashBalanceLabel")}}</span>
                                                {{walletDetails.previousBalance | number:'1.0-0'}}
                                            </td>
                                            <td>
                                                <span class="hide-mobile">{{setLabel("amountAddedLabel")}}</span>
                                                {{walletDetails.amountAdded | number:'1.0-0' }}
                                            </td>
                                            <td>
                                                <span class="hide-mobile">{{setLabel("newPettyCashBalanceLabel")}}</span>
                                                {{walletDetails.newBalance | number:'1.0-0'}}
                                            </td>
                                            <td>
                                                <span class="hide-mobile">{{setLabel("transactionNoLabel")}}</span>
                                                {{walletDetails.createdBy}}
                                            </td>
                                            <td>
                                                <span class="hide-mobile">{{setLabel("addedOnLabel")}}</span>
                                                {{walletDetails.createdOn | date:'dd/MM/yyyy'}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </p-tabPanel>
                        <p-dialog [header]='setLabel("addwalletAmountLabel")' [(visible)]="isWalletDialogVisible">
                            <div class="walletAmountPopup">
                                <div class="walletAmountPopupRow">
                                    <div>
                                        <label>{{setLabel("currentBalance:Label")}}</label>
                                    </div>
                                    <div>
                                        <label>{{walletAmount| number:'1.0-0'}}</label>
                                    </div>
                                </div>
                                <div class="walletAmountPopupRow">
                                    <div>
                                        <label>{{setLabel("addwalletAmountLabel")}}</label>
                                    </div>
                                    <div>
                                        <input type="number" name="pettyCash" [(ngModel)]="newWalletAmount" />
                                    </div>
                                </div>
                                <div class="walletAmountPopupRow">
                                    <div>
                                        <label>{{setLabel("newBalanceLabel")}}</label>
                                    </div>
                                    <div>
                                        <label>{{(+walletAmount) + (+newWalletAmount)| number:'1.0-0'}}</label>
                                    </div>
                                </div>
                                <div class="walletAmountPopupRow btnSave">
                                    <button pButton class="p-button-success"
                                        (click)="addWalletAmount()">{{setLabel("addwalletAmountLabel")}}</button>
                                </div>
                            </div>
                        </p-dialog>

                    <p-tabPanel *ngIf="showRelatedMembersTab()" [header]='setLabel("relatedMembersLabel")' headerStyleClass="related-members-tab">

                        <div class="rm-tab-wrapper">

                            <!-- Section header -->
                            <div class="rm-section-header">
                                <span class="rm-section-title">
                                    <i class="pi pi-users"></i>
                                    {{setLabel("groupMembersLabel")}}
                                </span>
                                <span class="rm-member-badge" *ngIf="relatedMembersGroup?.members?.length">
                                    {{relatedMembersGroup.members.length}}
                                    {{relatedMembersGroup.members.length === 1 ? 'member' : 'members'}}
                                </span>
                                <span class="rm-member-badge rm-shared-history-badge" *ngIf="isSameHistoryActive()">
                                    Same history
                                </span>
                            </div>

                            <!-- Table -->
                            <div class="rm-table-card">
                                <p-table
                                    [value]="relatedMembersGroup?.members || []"
                                    [loading]="relatedMembersLoading"
                                    class="feeTable hideTabileHeadOnMobile p-table-tecfolk-fix">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{setLabel("nameLabel")}}</th>
                                            <th>{{setLabel("membershipNumberLabel")}}</th>
                                            <th>{{setLabel("phoneLabel")}}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-relatedMember>
                                        <tr>
                                            <td>
                                                <span class="TrainingAttendencelabel mobile-hide">{{setLabel("nameLabel")}}</span>
                                                {{relatedMember.name}}
                                            </td>
                                            <td>
                                                <span class="TrainingAttendencelabel mobile-hide">{{setLabel("membershipNumberLabel")}}</span>
                                                {{relatedMember.tagNumber}}
                                            </td>
                                            <td>
                                                <span class="TrainingAttendencelabel mobile-hide">{{setLabel("phoneLabel")}}</span>
                                                {{relatedMember.phone}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="3" style="text-align:center; padding: 2rem 0; color: #6c757d;">
                                                <i class="pi pi-info-circle" style="margin-right:0.4rem;"></i>
                                                {{setLabel("noRelatedMembersFoundLabel")}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>

                            <!-- Action bar -->
                            <div class="rm-action-bar">
                                <button
                                    pButton
                                    type="button"
                                    [label]="setLabel('removeMeFromGroupLabel') + ' (' + member.name + ')'"
                                    icon="pi pi-user-minus"
                                    class="p-button-outlined p-button-danger rm-btn"
                                    [disabled]="!member.relatedMembersId"
                                    (click)="removeFromRelatedMembersGroup()">
                                </button>
                                <button
                                    pButton
                                    type="button"
                                    [label]="setLabel('addRelatedMemberLabel')"
                                    icon="pi pi-user-plus"
                                    class="p-button-outlined p-button-success rm-btn"
                                    [disabled]="addRelatedMemberOptionsLoading"
                                    [icon]="addRelatedMemberOptionsLoading ? 'pi pi-spin pi-spinner' : 'pi pi-user-plus'"
                                    (click)="openAddRelatedMemberDialog()">
                                </button>
                            </div>

                        </div>
                    </p-tabPanel>

                    </p-tabView>
            </div>
        </div>
    </div>
</div>

<p-dialog
    [header]="setLabel('addRelatedMemberLabel')"
    [(visible)]="addRelatedMemberDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '440px' }"
    styleClass="rm-add-dialog"
    appendTo="body">

    <div class="rm-dialog-dropdown-wrap">
        <label class="rm-dialog-field-label">
            <i class="pi pi-search" style="margin-right: 0.35rem; color: #5192d0;"></i>
            {{setLabel("selectMemberToAddLabel")}}
        </label>
        <p-dropdown
            name="selectedMemberToAdd"
            [options]="branchMembersOptions"
            [(ngModel)]="selectedMemberToAddId"
            [placeholder]="setLabel('typeToSearchMemberLabel')"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            appendTo="body"
            [style]="{ width: '100%' }">
        </p-dropdown>
    </div>

    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            [label]="setLabel('cancelLabel')"
            icon="pi pi-times"
            class="p-button-outlined p-button-secondary rm-btn"
            (click)="addRelatedMemberDialogVisible = false">
        </button>
        <button
            pButton
            type="button"
            [label]="setLabel('addMemberLabel')"
            icon="pi pi-check"
            class="p-button-success rm-btn"
            [disabled]="!selectedMemberToAddId"
            (click)="confirmAddRelatedMember()">
        </button>
    </ng-template>
</p-dialog>

<p-dialog
    header="Error Message"
    [(visible)]="trainerFeeErrorDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '420px' }"
    styleClass="trainer-fee-error-dialog"
    appendTo="body"
>
    <div class="trainer-fee-error-message">
        {{ trainerFeeErrorDialogMessage }}
    </div>
    <ng-template pTemplate="footer">
        <div class="trainer-fee-error-footer">
            <button
                pButton
                type="button"
                label="OK"
                class="p-button-primary"
                (click)="trainerFeeErrorDialogVisible = false"
            ></button>
        </div>
    </ng-template>
</p-dialog>
<div class="addMemberFee-res">
    <form #feeForm="ngForm" style="height: 310px; width: 570px;">
        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <p-dialog class="add-fee-main" [header]='setLabel("addFeeHeaderLabel")' [closeOnEscape]="true"
                    [visible]="dialogVisibility && feeInvoiceDialogCheck" (visibleChange)="dialogVisibility = $event">
                    <div class="p-g-12" style="margin-bottom: 2%; padding-top: 0%;padding-bottom: 0%;">
                        <div class="p-inputgroup" style="display: flex; align-items: center;">
                            <span style="padding-left: 1%;">{{setLabel("packageLabel")}}
                            </span>
                            <div class="p-g-12">
                                <div class="p-inputgroup">
                                    <input [readOnly]="true" autocomplete="off" pInputText name="packageName"
                                        [(ngModel)]="member.packageName">
                                    <!-- <p-dropdown [options]="
                                                    packagesDropDown
                                                " name="packageName" [style]="{
                                                    width: '100%'
                                                }" required (onChange)="
                                                    updatePackage(true)
                                                " [(ngModel)]="
                                                    member.packageId
                                                ">
                                    </p-dropdown> -->
                                    <span style="margin-left: 20px;">{{setLabel("noOfMonth(s)Label")}} <span
                                            style="font-weight: bold;">{{numOfMonths}}</span></span>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="p-g-12">
                        <div class="p-inputgroup" style="margin-bottom: 2%;padding-top: 0%;padding-bottom: 0%;">
                            <span *ngIf="member.question3 == 'YES'"
                                style="padding-left: 1%;">{{setLabel("trainerLabel")}} &nbsp;<span
                                    style="font-weight: bold;">{{memberTrainer}}</span></span>
                            <span *ngIf="member.question3 == 'NO'" style="padding-left: 1%;">
                                {{setLabel("trainerLabel")}} &nbsp;<span
                                    style="font-weight: bold;">{{setLabel("notAssignedLabel")}}</span></span>
                        </div>
                    </div>
                    <form #feeForm="ngForm" style="height: 310px; width: 570px">
                        <div class="p-g-12 p-md-12">
                            <!-- <div class="p-inputgroup">
                                <p-dropdown [options]="options" name="status" (onChange)="feeChange()"
                                    [style]="{ width: '100%' }" required [(ngModel)]="fund.status">
                                </p-dropdown>
                                <p-dropdown [options]="months" (onChange)="feeChange()" name="months"
                                    [style]="{ width: '100%' }" required [(ngModel)]="fund.month">
                                </p-dropdown>
                                <p-dropdown [options]="years" (onChange)="feeChange()" name="year"
                                    [style]="{ width: '100%' }" required [(ngModel)]="fund.year">
                                </p-dropdown>
                            </div> -->
                        </div>
                        <div class="p-g-12" style="padding-top: 17px; padding-bottom: 0px">
                            <div class="p-inputgroup" *ngIf="fund.status == 'Monthly Fee - Paid'">
                                <span class="p-g-3 p-inputgroup-addon" style="
                        padding-top: 5px !important;
                        padding-right: 11px !important;
                        text-align: start;
                    ">{{setLabel("nextDueDateLabel")}}
                                </span>
                                <p-calendar class="p-g-9 calendar-control" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="fund.dueDate"
                                    [Placeholder]='setLabel("dueDateLabel")' name="dueDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" [disabled]="isDateDisabled()">
                                </p-calendar>
                            </div>
                        </div>


                        <div class="p-g-12 p-md-12" style="padding-top: 0px">
                            <div class="p-inputgroup">
                                <span *ngIf="fund.status === 'Monthly Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("monthlyFeeLabel")}}</span>
                                <span *ngIf="fund.status === 'Registration Fee - Paid' "
                                    class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("registrationFeeLabel")}}</span>
                                <span *ngIf="fund.status === 'Trainer Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("trainerFeeLabel")}}</span>
                                <span *ngIf="fund.status === 'Fine Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                    style="width: 28%; text-align: start;">{{setLabel("fineFeeLabel")}}</span>
                                <div class="p-inputgroup-fee-error-fix">
                                    <input class="p-g-8" type="number" required pattern="[0-9]+" autocomplete="off"
                                        pInputText [title]='setLabel("packageFeeLabel")' name="fundPay"
                                        [(ngModel)]="fund.pay" #fundPay="ngModel" [ngClass]="

                                            fundPay.invalid && (fundPay.dirty || fundPay.touched)
                                                ? 'errorInput'
                                                : ''
                                        " />
                                    <div class="error_space"
                                        *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
                                        <div *ngIf="fundPay.errors.required" class="errorShow">
                                            {{setLabel("enterFeeCorrectlyLabel")}}
                                        </div>
                                        <div *ngIf="fundPay.errors.pattern" class="errorShow">
                                            {{setLabel("enterFeeCorrectlyLabel")}}
                                        </div>
                                    </div>
                                </div>
                                <span class="p-g-1 p-inputgroup-addon">.00</span>
                            </div>

                            <div class="p-g-12 p-md-12" style="padding-top: 10px; padding-left: 0 !important;"
                                *ngIf="fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid'">
                                <div class="p-inputgroup">
                                    <span *ngIf="fund.status === 'Monthly Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                        style="width: 28%; text-align: start;">{{setLabel("monthlyDiscountLabel")}}
                                    </span>
                                    <span *ngIf="fund.status === 'Registration Fee - Paid' "
                                        class="p-g-3 p-inputgroup-addon"
                                        style="width: 28%; text-align: start;">{{setLabel("registrationDiscountLabel")}}</span>
                                    <span *ngIf="fund.status === 'Trainer Fee - Paid' " class="p-g-3 p-inputgroup-addon"
                                        style="width: 28%; text-align: start;">{{setLabel("trainerDiscountLabel")}}</span>
                                    <div class="p-inputgroup-fee-error-fix">
                                        <input id="discountAmount" class="p-g-8" type="number" pattern="[0-9]+"
                                            autocomplete="off" pInputText
                                            [Placeholder]='setLabel("discountAmountLabel")' name="discount"
                                            [(ngModel)]="discountAmount" #discount="ngModel"
                                            (ngModelChange)="validateDiscount()" />
                                    </div>
                                    <span class="p-g-1 p-inputgroup-addon">.00</span>
                                </div>
                                <div *ngIf="showMonthlyFeeError"
                                    style="text-align: right; margin-right: 31px; color: red;">
                                    {{setLabel("greaterMonthlyFeeLabel")}}</div>
                                <div *ngIf="showRegistrationFeeError"
                                    style="text-align: right; margin-right: 31px; color: red;">
                                    {{setLabel("greaterRegistrationFeeLabel")}}</div>
                                <div *ngIf="showTrainerFeeError"
                                    style="text-align: right; margin-right: 31px; color: red;">
                                    {{setLabel("greaterTrainerFeeLabel")}}</div>

                            </div>
                            <div class="p-g-12 p-md-12" style="padding-left: 0 !important;"
                                *ngIf="fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid'">
                                <div class="p-inputgroup" style="border: none;">
                                    <span id="afterDiscountFee" class="p-inputgroup-addon"
                                        style="width: 28% !important; margin-right: 2px !important; font-weight: bold; text-align: start;">{{setLabel("afterDiscountFeeLabel")}}</span>

                                    <span *ngIf="fund.status === 'Monthly Fee - Paid' " style="margin-top: 2%; ">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) =
                                        {{fund.pay - ( discountAmount
                                        ) }}
                                    </span>

                                    <span *ngIf="fund.status === 'Registration Fee - Paid' " style="margin-top: 2%; ">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) = {{
                                        fund.pay - discountAmount
                                        }}
                                    </span>
                                    <span *ngIf="fund.status === 'Trainer Fee - Paid' " style="margin-top: 2%; ">
                                        {{ fund.pay }} - {{ discountAmount }} ({{setLabel("discountLabel")}}) = {{
                                        fund.pay - discountAmount
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div class="p-g-12 p-md-12">
                                <div class="p-inputgroup">
                                    <span class="p-g-3 p-inputgroup-addon"
                                        style="width: 29%; text-align: start;">{{setLabel("modeOfPaymentDropdownLabel")}}</span>
                                    <!-- <p-dropdown class="p-g-8" [options]="paymentOptions"
                                        (onChange)="onPaymentModeChange($event.value)"></p-dropdown> -->
                                    <span class="p-g-1"></span>
                                </div>
                            </div>
                            <button *ngIf="paymentMode && paymentMode.includes('Online-')" pButton
                                class="p-button-success" style="margin-left: 30%;"
                                [pTooltip]='setLabel("uploadReceiptTooltipLabel")' tooltipPosition="top"
                                (click)="onUploadButtonClick()">
                                <span class="p-button-text p-c">
                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                    &nbsp;{{setLabel("uploadReceiptBtnLabel")}}
                                </span>
                            </button>
                            <!-- <input id="fileInput" type="file" style="display: none" (change)="fileChangeEvent($event)"> -->
                            <div *ngIf="selectedFileName" style="margin-left: 30%;">
                                {{setLabel("selectedFileInputLabel")}}: {{ selectedFileName }}
                            </div>
                            <div class="p-g-12 p-md-12" style="padding-top: 10px; padding-left: 0 !important;"
                                *ngIf="fund.status === 'Monthly Fee - Paid' || fund.status === 'Registration Fee - Paid' || fund.status === 'Trainer Fee - Paid'">
                                <div class="p-inputgroup">
                                    <span *ngIf="fund.status === 'Trainer Fee - Paid'" class="p-g-3 p-inputgroup-addon"
                                        style="width: 28%; text-align: start;">{{setLabel("trainerSessionsSpanLabel")}}
                                    </span>
                                    <div *ngIf="fund.status === 'Trainer Fee - Paid'"
                                        class="p-inputgroup-fee-error-fix">
                                        <input id="trainerSessions" class="p-g-8" type="number" pattern="[0-9]+"
                                            autocomplete="off" pInputText
                                            [Placeholder]='setLabel("trainerSessionsPlaceholderLabel")' name="sessions"
                                            [(ngModel)]="trainerSessions" #sessions="ngModel" required />
                                        <div *ngIf="sessions.invalid && (sessions.dirty || sessions.touched)"
                                            class="error-message" style="color: red;">
                                            {{setLabel("trainerSessionsRequiredErrorLabel")}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-g-12 p-md-12">
                                <div class="p-inputgroup">
                                    <span class="p-g-3 p-inputgroup-addon"
                                        style="width: 29%; text-align: start;">{{setLabel("commentLabel")}}</span>
                                    <textarea class="p-g-8" style="width: 67% !important" rows="5" cols="50"
                                        [(ngModel)]="fund.description" name="description" pInputTextarea></textarea>
                                    <span class="p-g-1"></span>
                                </div>

                            </div>
                        </div>
                        <p-footer>
                            <div>
                                <!-- <button (click)="addFund()" [disabled]="
                        !feeForm.valid ||
                        feegreater == true ||
                        feealreadypaid == true ||
                        trainerNotSelected
                    " pButton type="button" [label]='setLabel("saveBtnLabel")' icon="pi pi-save" class="p-button-success" style="
                        float: right !important;
                        margin-right: 42px !important;
                        margin-top: 17px;
                    "></button> -->
                                <br />
                                <br />
                                <div class="alert alert-warning" style="float: right !important; margin-top: 18px">
                                    <p-message severity="warn" text="Fee already paid"
                                        *ngIf="feealreadypaid"></p-message>
                                </div>
                                <div class="alert alert-danger" style="float: right !important; margin-top: 18px">
                                    <p-message severity="error"
                                        text="Please Select Trainer First in Trainer Details Tab..."
                                        *ngIf="trainerNotSelected"></p-message>
                                </div>
                                <div class="alert alert-danger" style="float: right !important; margin-top: 6px">
                                    <p-message severity="error" text="You cannot pay more than actual Fee"
                                        *ngIf="feegreater">
                                    </p-message>
                                </div>
                            </div>
                        </p-footer>
                    </form>
                </p-dialog>
            </div>
        </div>
    </form>

</div>
<div *ngIf="imgPreview" (click)="closePhotoPreview()"
    style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
    <svg (click)="closePhotoPreview()"
        style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
        aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
        role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
        <path fill="currentColor"
            d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
        </path>
    </svg>
    <img [src]="imgPreviewImg" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
        style="max-width: 90%; max-height: 90%; width: auto; height: auto; object-fit: contain;">
</div>


<!-- <div *ngIf="dialogVisible">
                        <p-dialog header="Capture Photo" [(visible)]="dialogVisible">
                  <app-camera (pictureTaken)="handleImage($event)"></app-camera>
                </p-dialog>
                    </div> -->
<div *ngIf="isShowAddProfileImage" class="tecfolkProfileDialogFix">
    <p-dialog [header]='setLabel("addProfilePhotoHeaderLabel")' [(visible)]="isShowAddProfileImage">
        <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
            (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
    </p-dialog>
    <!-- popupType : Upload | Cam -->
</div>

<p-dialog [(visible)]="showEmailSingleReceiptConfirmationBox" class="singleReceiptsEmail" [closeOnEscape]="true"
    [focusOnShow]="false" [style]="{ width: '54vw', left: '10px', top: '24px' }">
    <p-header>{{setLabel("sendReceiptLabel")}}</p-header>
    <form #emailConfirmationForm1="ngForm">
        <div style="height: 60vh">
            <!-- <h3 class="first" style="font-weight: 400;">To</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("sendToTooltipLabel")'
                        tooltipPosition="top"><i class="fa fa-user" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.to"
                        pattern="^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+,*[\W]*)+$" type="text" pInputText
                        [title]='setLabel("toPlaceholderLabel")' name="to" required />
                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Subject</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("subjectTooltipLabel")'
                        tooltipPosition="top"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.subject" type="text" pInputText
                        [title]='setLabel("subjectPlaceholderLabel")' name="subject" required />
                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Body</h3> -->
            <div class="p-g-12 ck-editor_bodyScroll">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("bodyTooltipLabel")' tooltipPosition="top"><i
                            class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                    <ckeditor name="ckeditor" style="
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        " [editor]="Editor" [(ngModel)]="email.body"></ckeditor>
                    <!-- <p-editor [(ngModel)]="email.body" style="width: 100%;" name="body" [style]="{'height':'320px'}"></p-editor> -->
                </div>
            </div>
            <!-- <div class="p-g-12">
<div class="p-inputgroup">
    <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
    <textarea class="textarea" rows="5" cols="80" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
    [(ngModel)]="email.body" placeholder="Body" name="body" pInputTextarea></textarea>
</div>
</div> -->
        </div>
        <p-footer>
            <div class="email-button">
                <button style="background: #e7e7e7; color: black;" (click)="closeEmailConfirmation()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("cancelLabel")}}
                </button>
                <button [disabled]="!emailConfirmationForm1.valid" style="background: #4caf50; color: white;"
                    (click)="sendInvoiceEmailAsPdf()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("sendLabel")}}
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>

<p-dialog [(visible)]="showEmailReceiptConfirmationBox" class="allReceiptsEmail" [closeOnEscape]="true"
    [focusOnShow]="false" [style]="{ width: '54vw', left: '10px', top: '24px' }">
    <p-header>{{setLabel("sendReceiptLabel")}}</p-header>
    <form #emailConfirmationForm2="ngForm">
        <div style="display: flex; flex-direction: column;">
            <!-- <h3 class="first" style="font-weight: 400;">To</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("sendToTooltipLabel")'
                        tooltipPosition="top"><i class="fa fa-user" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.to"
                        pattern="^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+,*[\W]*)+$" type="text" pInputText
                        [title]='setLabel("toPlaceholderLabel")' name="to" required />
                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Subject</h3> -->
            <div class="p-g-12" style="padding-bottom: 20px">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("subjectTooltipLabel")'
                        tooltipPosition="top"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                    <input autocomplete="off" [(ngModel)]="email.subject" type="text" pInputText
                        [title]='setLabel("subjectPlaceholderLabel")' name="subject" required />
                </div>
            </div>
            <!-- <h3 class="first" style="font-weight: 400;">Body</h3> -->
            <div class="p-g-12 ck-editor_bodyScroll">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" [pTooltip]='setLabel("bodyTooltipLabel")' tooltipPosition="top"><i
                            class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                    <ckeditor name="ckeditor" style="
            width: 100%;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        " [editor]="Editor" [(ngModel)]="email.body"></ckeditor>
                    <!-- <ckeditor></ckeditor> -->
                </div>
            </div>
            <!-- <div class="p-g-12">
<div class="p-inputgroup">
    <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
    <textarea class="textarea" rows="5" cols="80" style="width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
    [(ngModel)]="email.body" placeholder="Body" name="body" pInputTextarea></textarea>
</div>
</div> -->
        </div>
        <p-footer>
            <div class="email-button">
                <button style="background: #e7e7e7; color: black; margin: 10px;" (click)="closeEmailConfirmation()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("cancelLabel")}}
                </button>
                <button [disabled]="!emailConfirmationForm2.valid"
                    style="background: #4caf50; color: white; margin: 10px;" (click)="sendInvoiceEmailAsPdf()"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("sendLabel")}}
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>

<p-dialog [(visible)]="showActiceFreezeBox" [closeOnEscape]="true" [focusOnShow]="false"
    [style]="{ width: '32%', left: '582px', top: '196px' }">
    <p-header>{{setLabel("confirmationLabel")}}</p-header>
    <form>
        <div style="display: grid">
            <!--start flex-->
            <div class="p-g-12" style="padding-bottom: 20px">
                <div style="display: flex;flex-direction: row;justify-content: space-between;">
                    <div style="display: flex;justify-content: space-between;flex-direction: row;align-items: center;">
                        <i class="fa fa-exclamation-circle" aria-hidden="true" style="margin-right: 8px"></i>
                        <p>{{setLabel("doYouActivateMemberLabel")}}</p>
                    </div>

                    <div style="align-items: center;text-align: center;display: flex;">
                        <button (click)="activateMember()" class="p-button-primary" *ngIf="member.isDelete === true"
                            pButton type="button" label="Activate Member" icon="fa fa-check"
                            style="background-color: #e91e63; width: 116px"></button>
                        <button class="p-button-primary" *ngIf="member.isDelete === false" disabled pButton
                            type="button" label="Activated" icon="fa fa-check"
                            style="background-color: #e91e63; width: 116px"></button>
                    </div>
                </div>

                <div style="display: flex;flex-direction: row;justify-content: space-between;">
                    <div style="display: flex;justify-content: space-between;flex-direction: row;align-items: center;">
                        <i class="fa fa-exclamation-circle" aria-hidden="true" style="margin-right: 8px"></i>
                        <p>{{setLabel("doDefreeze?Label")}}</p>
                    </div>

                    <div style="align-items: center;text-align: center;display: flex;">
                        <button (click)="defreezeMember(member)" *ngIf="member.freezeDetail.isFreeze === true" pButton
                            type="button" label="Unfreeze" icon="fa fa-thermometer-empty" class="p-button-primary"
                            style="background-color: #3f51b5; width: 116px"></button>
                        <button *ngIf="member.freezeDetail.isFreeze === false" disabled pButton type="button"
                            label="Unfrozen" icon="fa fa-thermometer-empty" class="p-button-primary"
                            style="background-color: #3f51b5; width: 116px"></button>
                    </div>
                </div>

                <!--End flex-->
                <!-- <div style="display: flex;">
    <div style="display: flex;flex-direction: row; padding: 9px;vertical-align: middle;">
        <div>
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        </div>
        <div>
            <p style="padding-left:6px; position: absolute; margin-top: -1px;">Do you want to de-freeze this member ?</p>
        </div>
    </div>
    <div style="margin-left: 297px;">
        <button (click)="defreezeMember(member)" *ngIf="member.freezeDetail.isFreeze === true" pButton type="button"
            label="DeFreeze" icon="fa fa-thermometer-empty" class="p-button-primary"
            style="background-color: #3F51B5; width: 149%;"></button>
        <button *ngIf="member.freezeDetail.isFreeze === false" disabled pButton type="button" label="DeFreezed"
            icon="fa fa-thermometer-empty" class="p-button-primary" style="background-color: #3F51B5; width: 149%;"></button>
    </div>
</div> -->
            </div>

            <!--End flex-->
        </div>
        <p-footer>
            <div style="display: flex; flex-flow: row-reverse">
                <button style="background: #e7e7e7; color: black; margin-top: 10px"
                    (click)="showActiceFreezeBox = false"
                    class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                    {{setLabel("closeLabel")}}
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>

<p-dialog [(visible)]="showCommentBox" [closeOnEscape]="true" [focusOnShow]="false"
    [style]="{ width: '36vw', left: '570px', top: '288px' }">
    <p-header>{{setLabel("invoiceCommentLabel")}}</p-header>
    <form>
        <div style="height: 140px">
            <div class="p-g-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
                    <textarea class="textarea" rows="5" readonly cols="80" style="width: 100%; height: 120px; -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box; box-sizing: border-box;
        " [(ngModel)]="fund.description" [title]='setLabel("commentLabel")' name="body" pInputTextarea></textarea>
                </div>
            </div>
        </div>
        <!-- <p-footer>
<div style="display: flex;justify-content: space-between;">
<button style="background: #e7e7e7; color:black;margin-top: 10px;" (click)="closeEmailConfirmation()"
    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Cancel</button>
<button [disabled]="!emailConfirmationForm.valid" style="background: #4CAF50; color:white;margin-top: 10px;" (click)="sendInvoiceEmailAsPdf()"
    class="p-button p-widget p-state-default p-corner-all p-button-text-only">Send</button>

</div>
</p-footer> -->
    </form>
</p-dialog>


<p-dialog
  header="{{ setLabel('complimentaryFreezeDialogHeaderLabel') || 'Complimentary Freeze Request' }}"
  [(visible)]="complimentaryFreezeDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ 'width': '430px', 'border-radius': '5px' }"
>
    <div class="p-fluid">
        <div class="p-field" style="margin-bottom: 12px;">
            <label>{{ setLabel('availableComplimentaryDaysLabel') }}</label>
            <input pInputText [readonly]="true" [value]="getAvailableComplimentaryFreezingDays()" />
        </div>

        <div class="p-field" style="margin-bottom: 12px;">
            <label>{{ setLabel('complimentaryFreezeFromDateLabel') }}</label>
            <p-calendar
                [(ngModel)]="complimentaryFreezeStartDate"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [minDate]="minComplimentaryFreezeDate"
                (onSelect)="onComplimentaryFreezeDateChange()"
            ></p-calendar>
        </div>

        <div class="p-field" style="margin-bottom: 12px;">
            <label>{{ setLabel('complimentaryFreezeToDateLabel') }}</label>
            <p-calendar
                [(ngModel)]="complimentaryFreezeEndDate"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                [minDate]="getComplimentaryFreezeEndMinDate()"
                (onSelect)="onComplimentaryFreezeDateChange()"
            ></p-calendar>
        </div>

        <div class="p-field" style="margin-bottom: 6px; font-weight: 600;">
            {{ setLabel('complimentaryFreezeSelectedDaysLabel') }}: {{ complimentaryFreezeSelectedDays || 0 }}
        </div>
    </div>

    <p-footer class="dialog-footer">
        <button
            pButton
            style="border-radius: 20px;"
            type="button"
            [label]="setLabel('cancelRequestBtnLabel')"
            class="p-button-secondary"
            (click)="complimentaryFreezeDialogVisible = false"
        ></button>
        <button
            pButton
            type="button"
            style="border-radius: 20px;"
            [label]="setLabel('submitRequestBtnLabel')"
            [disabled]="complimentaryFreezeSubmitting"
            (click)="submitComplimentaryFreezeRequest()"
            class="p-button-success"
        ></button>
    </p-footer>
</p-dialog>





<p-dialog
  header="{{ setLabel('extendFreezeBtnLabel') || 'Extend Freeze Days' }}"
  [(visible)]="extendFreezeDaysDialog"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ 'width': '400px', 'border-radius': '5px' }"
  (onHide)="closeAddFreezingDaysDialog()"
  styleClass="custom-freeze-dialog"
>

<div class="p-g-12 p-md-12">
  <div class="p-inputgroup">

    <!-- Fixed Status Display -->
    <span class="p-inputtext" style="width: 32%; ; font-weight: 600;margin-bottom:10px;">
      Paid Freezing Fee
    </span>

  </div>
</div>
  <div class="p-fluid custom-freeze-content">
    <!-- Input for Days -->
    <div class="p-field mb-3 custom-freeze-fee-input">
      <label for="freezeDays">{{ setLabel('enterFreezeDaysLabel') || 'Enter Days:' }}</label>
      <input
        id="freezeDays"
        type="number"
        pInputText
        placeholder="Enter days"
        [(ngModel)]="freezeDays"
        min="1"
      />
    </div>

    <!-- Input for Fee -->
    <div class="p-field mb-3 custom-freeze-fee-input">
      <label for="freezeAmount">{{ setLabel('freezeFeeLabel') || 'Freeze Fee:' }}</label>
      <input
        id="freezeAmount"
        type="number"
        pInputText
        placeholder="Enter amount"
        [(ngModel)]="freezeAmount"
        min="1"
      />
    </div>

    <!-- Total Amount -->
    <div class="text-center mt-3 custom-freeze-total-amount">
        <span style="font-weight: bold; color: blue; font-size: 1rem;">
        {{ setLabel('totalFreezeAmountLabel')}}
        </span>
      <span style="font-weight: bold; color: blue; font-size: 1rem;">
            {{ freezeDays || 0 }} × {{ freezeAmount || 0 }} =
            {{ (freezeDays && freezeAmount) ? (freezeDays * freezeAmount) : 0 }}
      </span>
    </div>
  </div>

   <div class="p-g-12 p-md-12">
        <div class="p-inputgroup">
            <span class="p-g-3 p-inputgroup-addon"
                style="width: 29%; text-align: start; border-bottom: 1px solid rgb(36, 36, 36);">{{setLabel("modeOfPaymentDropdownLabel")}}</span>
            <p-dropdown class="p-g-8" [options]="paymentOptions"
                [(ngModel)]="selectedPaymentMode"
                appendTo="body"
                (onChange)="onFreezePaymentModeChange($event.value)"></p-dropdown>
            <span class="p-g-1"></span>
        </div>
    </div>

    <div class="p-g-12 p-md-12">
        <div class="p-inputgroup">
            <span class="p-g-3 p-inputgroup-addon"
                style="width: 29%; text-align: start;">{{setLabel("commentLabel")}}</span>
            <textarea class="p-g-8" style="width: 67% !important" rows="5" cols="50"
                [(ngModel)]="freezeFeeDescription" name="freezeFeeDescription" pInputTextarea></textarea>
            <span class="p-g-1"></span>
        </div>

    </div>
  <!-- Footer -->
  <div class="custom-freeze-footer">
    <button
      pButton
      (click)="addFreezingFeeAndDays(member)"
      label="{{ setLabel('collectFreezeFeeLabel') }}"
      class="custom-freeze-button"
    ></button>
  </div>
</p-dialog>

<div *ngIf="feeInvoiceDialog">
    <app-add-fee [memberID]="memberID" [customerFees]="customerFees" [trainerSharePercentage]="member.customerstrainer.trainerSharePercentage" [gymSharePercentage]="member.customerstrainer.gymSharePercentage"
        (closeFeeCollectionDialog)="closeFeeCollectionDialog()"></app-add-fee>
</div>

<p-dialog [header]='setLabel("changeModeOfPaymentDropdownLabel")'
    [(visible)]="isChangePaymentModeDialogVisible" [modal]="true"
    (onHide)="clearPaymentModeReceiptSelection()"
    styleClass="change-payment-mode-dialog">
    <div class="change-payment-mode-form">
        <div class="change-payment-mode-row">
            <label class="change-payment-mode-label">{{setLabel("modeOfPaymentDropdownLabel")}}</label>
            <p-dropdown class="change-payment-mode-field" [options]="paymentOptions"
                name="changePackageName"
                [(ngModel)]="selectedPaymentMode"
                (onChange)="onPaymentModeDialogSelectionChange()">
            </p-dropdown>
        </div>
        <div *ngIf="shouldShowPaymentModeReceiptUpload()" class="change-payment-mode-row">
            <label class="change-payment-mode-label">{{setLabel("uploadReceiptBtnLabel")}}</label>
            <div class="change-payment-mode-field change-payment-mode-upload-wrap">
                <button type="button" pButton
                    class="p-button-success change-payment-mode-upload-btn"
                    [pTooltip]='setLabel("uploadReceiptTooltipLabel")'
                    tooltipPosition="top"
                    (click)="onPaymentModeReceiptUploadClick()">
                    <span class="change-payment-mode-upload-btn-content">
                        <i class="fa fa-upload" aria-hidden="true"></i>
                        <span>{{setLabel("uploadBtnLabel")}}</span>
                    </span>
                </button>
                <span *ngIf="paymentModeReceiptFileName" class="change-payment-mode-file-name">
                    {{setLabel("selectedFileInputLabel")}}: {{ paymentModeReceiptFileName }}
                </span>
                <input id="paymentModeReceiptFileInput" type="file" accept="image/*,application/pdf"
                    style="display: none" (change)="onPaymentModeReceiptFileSelected($event)" />
            </div>
        </div>
    </div>

    <p-footer class="dialog-footer">
        <button type="button"
            (click)="isChangePaymentModeDialogVisible = false" pButton
            style="border-radius:5px; " [label]='setLabel("cancelLabel")'
            class="p-button-secondary"></button>
        <button type="button"
            (click)="onPaymentModeDialogUpdate()" pButton
            style="border-radius:5px; "
            [label]='setLabel("updateBtnLabel")'></button>
    </p-footer>
</p-dialog>

<p-dialog [header]='setLabel("changeInvoiceDateLabel")'
    [(visible)]="isChangeInvoiceDateDialogVisible" [modal]="true">
    <div style="display:flex; flex-direction:column; row-gap:10px; ">
        <span>{{setLabel("selectInvoiceDateLabel")}}</span>
        <div *ngIf="invoiceDateEditTarget === 'memberFee' && splitInvoiceDateGroupCount > 1"
            class="split-invoice-date-sync-note">
            <span>{{ getSplitInvoiceDateSyncNoteLine1() }}</span>
            <span>{{ setLabel('splitInvoiceDateSyncNoteLine2Label') }}</span>
        </div>
        <p-calendar [yearNavigator]="true" yearRange="2010:2040"
            [monthNavigator]="true" [(ngModel)]="selectedInvoiceDate"
            [placeholder]='setLabel("selectInvoiceDateLabel")' name="invoiceDate"
            [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true" [showTime]="true">
        </p-calendar>
    </div>

    <p-footer class="dialog-footer">
        <button type="button"
            (click)="isChangeInvoiceDateDialogVisible = false" pButton
            style="border-radius:5px; " [label]='setLabel("cancelLabel")'
            class="p-button-secondary"></button>
        <button type="button"
            (click)="updateInvoiceDate(selectedInvoiceDate)" pButton
            style="border-radius:5px; "
            [label]='setLabel("updateBtnLabel")'></button>
    </p-footer>
</p-dialog>
<div class="addSubscriptionWrapper" id="subscriptionPopupWrapper">
    <p-dialog [header]='setLabel("addSubscriptionHeaderLabe")' [(visible)]="addSubscriptionPopupVisible" [modal]="true"
        [style]="{ width: '765px' }" [draggable]="false" [resizable]="false">
        <div class="loadingSubscription" *ngIf="SubscriptionPopupLoading">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff" width="30px">
                <path
                    d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
            </svg>
        </div>
        <div class="addSubscriptionMain">
            <div class="addSubscriptionItem">
                <label>{{setLabel("selectSubscriptionLabel")}}</label>
                <p-cascadeSelect
                    appendTo="body"
                    styleClass="add-subscription-cascade-field"
                    panelStyleClass="add-subscription-cascade-panel"
                    [overlayOptions]="subscriptionCascadeOverlayOptions"
                    (onChange)="subscriptionSelectionChanged()"
                    [(ngModel)]="selectedSubscription"
                    [options]="allSubscriptions"
                    optionLabel="feeName"
                    optionGroupLabel="name"
                    [optionGroupChildren]="['trainers', 'fees']"
                    [style]="{ minWidth: '14rem', width: '100%' }"
                    [placeholder]='setLabel("selectSubscriptionPlaceholderLabel")'></p-cascadeSelect>
            </div>
            <div class="addSubscriptionItem">
                <label>{{setLabel("trainerLabel")}}</label>
                <span class="lookLikeInput">
                    {{ serviceType === 'selfService' ? 'Self Service' : (selectedTrainerInSubscriptionDb ? selectedTrainerInSubscriptionDb.name : 'Subscription not selected') }}
                </span>
            </div>
            <div class="addSubscriptionItem">
                <label>{{setLabel("trainerPackageLabel")}}</label>
                <span class="lookLikeInput">
                    {{serviceType === 'selfService' ? 'Self Service' : (selectedTrainerInSubscriptionDb ? selectedTrainerFee?.title : "Subscription not selected") }}</span>

            </div>
            <div class="addSubscriptionItem" *ngIf="shouldShowNumberOfMonthsInSubscriptionPopup()">
                <label>{{setLabel("numberOfMonthsLabel") || 'Number of Months'}}</label>
                <span class="lookLikeInput">{{ getSubscriptionMonthsCount() }}</span>
            </div>
            <div class="addSubscriptionItem" *ngIf="shouldShowNumberOfSessionsInSubscriptionPopup() || !shouldShowNumberOfMonthsInSubscriptionPopup()">
                <label>{{setLabel("numberSessionsLabel")}}</label>
                <span class="lookLikeInput">{{ getSubscriptionSessionsCount() }}</span>
            </div>
            <div class="addSubscriptionItem" *ngIf="!(serviceType == 'selfService' && selectedTrainerFee?.packageType == 'One Time')">
                <label>{{setLabel("sessionsStartDateLabel")}}</label>
                <p-calendar [yearNavigator]="true" yearRange="2020:2050" appendTo="body" [monthNavigator]="true"
                    [(ngModel)]="sessionsStartDate" [placeholder]='setLabel("sessionsStartDatePlaceholderLabel")'
                    name="sessionsStartDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
                    (ngModelChange)="onSubscriptionStartDateChange()"
                    [disabled]="serviceType == 'selfService' && (selectedTrainerFee?.packageType == 'Month Wise' || selectedTrainerFee?.packageType == 'Session Wise')"></p-calendar>
            </div>
            <div class="addSubscriptionItem" *ngIf="serviceType == 'selfService' && selectedTrainerFee?.packageType == 'One Time'">
                <label>{{setLabel("sessionsStartDateLabel")}}</label>
                <span class="lookLikeInput">-</span>
            </div>
            <div class="addSubscriptionItem" *ngIf="shouldShowSubscriptionEndDate()">
                <label>{{setLabel("endDateLabel")}}</label>
                <p-calendar [yearNavigator]="true" yearRange="2020:2050" appendTo="body" [monthNavigator]="true"
                    [(ngModel)]="sessionsEndDate" placeholder="Select End Date"
                    name="sessionsEndDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true"
                    [disabled]="isAutoCalculatedSubscriptionEndDate()"></p-calendar>
            </div>
            <div class="addSubscriptionItem" *ngIf="serviceType == 'selfService' && selectedTrainerFee?.packageType == 'One Time'">
                <label>{{setLabel("endDateLabel")}}</label>
                <span class="lookLikeInput">-</span>
            </div>
            <div class="addSubscriptionItem">
                <label>{{setLabel("multiplePaymentModesLabel")}}</label>
                <div class="subscriptionSplitToggleRow">
                    <p-inputSwitch
                        [ngModel]="subscriptionMultiplePaymentModesEnabled"
                        (ngModelChange)="onSubscriptionSplitToggle($event)"></p-inputSwitch>
                </div>
            </div>
            <div class="addSubscriptionItem" *ngIf="!subscriptionMultiplePaymentModesEnabled">
                <label>{{setLabel("paymentModeLabel")}}</label>
                <p-dropdown
                    [options]="paymentOptions"
                    [(ngModel)]="paymentMode"
                    appendTo="body"
                    (onChange)="onSubscriptionPaymentModeChange($event.value)"></p-dropdown>
            </div>
            <div *ngIf="branch._id !== '67728682419e66d9220356ec' " class="addSubscriptionItem">
                <label>{{setLabel("subscriptionFeeLabel")}}</label>
                <input type="number" pInputText [disabled]="true" [(ngModel)]="subscriptionFee"
                    (ngModelChange)="onSubscriptionSplitAmountChange()" />
            </div>
            <div *ngIf="branch._id == '67728682419e66d9220356ec' " class="addSubscriptionItem">
                <label>{{setLabel("subscriptionFeeLabel")}}</label>
                <input type="number" pInputText [(ngModel)]="subscriptionFee"
                    (ngModelChange)="onSubscriptionSplitAmountChange()" />
            </div>
            <div class="addSubscriptionItem">
                <label>{{setLabel("discountLabel")}}</label>
                <input type="number" pInputText min="0" [(ngModel)]="subscriptionDiscount"
                    (ngModelChange)="onDiscountChange()" min="0"
                    oninput="this.value = Math.max(0, parseInt(this.value) || 0)" pattern="^[0-9]*$" />
                <div *ngIf="subscriptionDiscount > subscriptionFee" class="errorShow">
                    {{setLabel("feeExceedLabel")}}
                </div>
            </div>
            <div class="subscription-split-panel-row" *ngIf="subscriptionMultiplePaymentModesEnabled">
                <div class="subscription-split-section">
                    <div class="subscription-payment-rows">
                        <div class="subscription-split-header">
                            <span [pTooltip]="setLabel('modeOfPaymentDropdownLabel')" tooltipPosition="top">{{ setLabel("paymentColumnLabel") }}</span>
                            <span>{{ setLabel("amountLabel") }}</span>
                            <span>{{ setLabel("taxLabel") }}</span>
                            <span>{{ setLabel("subTotalLabel") }}</span>
                            <span></span>
                        </div>
                        <div class="subscription-payment-row"
                            *ngFor="let row of subscriptionPaymentSplits; trackBy: trackSubscriptionSplitRowById">
                            <p-dropdown [options]="getSubscriptionSplitPaymentOptionsForRow(row.id)" [name]="'subSplitMode_' + row.id"
                                [(ngModel)]="row.paymentMode" appendTo="body" placeholder="Payment mode"
                                (onChange)="onSubscriptionSplitModeChange(row, $event?.value ?? row.paymentMode)">
                            </p-dropdown>
                            <input type="number" pInputText [name]="'subSplitPay_' + row.id"
                                [ngModel]="row.pay" min="0" placeholder="Amount"
                                (ngModelChange)="onSubscriptionSplitPayChange(row, $event)" />
                            <span class="subscription-row-tax">
                                <ng-container *ngIf="row.taxType === 'INCLUDING_TAX' && row.includedTax">
                                    {{ row.includedTax | number:'1.0-0' }}
                                </ng-container>
                                <ng-container *ngIf="row.taxType !== 'INCLUDING_TAX' || !row.includedTax">
                                    {{ row.tax | number:'1.0-0' }}
                                </ng-container>
                            </span>
                            <span class="subscription-row-total">{{ row.lineTotal | number:'1.0-0' }}</span>
                            <button pButton type="button"
                                class="p-button-danger p-button subscription-split-remove-btn"
                                icon="fa fa-times"
                                (click)="removeSubscriptionSplitRow(row.id)"
                                [disabled]="subscriptionPaymentSplits.length <= 2"
                                [pTooltip]="subscriptionPaymentSplits.length <= 2 ? setLabel('minTwoPaymentModesTooltipLabel') : setLabel('removePaymentModeTooltipLabel')"
                                tooltipPosition="top"></button>
                        </div>
                        <button type="button" pButton [label]="setLabel('addPaymentLineBtnLabel')"
                            class="p-button subscription-add-payment-line-btn"
                            (click)="addSubscriptionSplitRow()"></button>
                        <div class="subscription-allocated-hint"
                            [ngClass]="isSubscriptionSplitAllocationValid() ? 'valid' : 'invalid'">
                            {{ setLabel("allocatedLabel") }}: {{ allocatedSubscriptionSplitTotal | number:'1.0-0' }} / {{ getSubscriptionSplitAllocationTarget() | number:'1.0-0' }}
                        </div>
                        <div *ngIf="subscriptionSplitValidationMessage" class="subscription-split-validation-error">
                            {{ subscriptionSplitValidationMessage }}
                        </div>
                        <div class="subscription-split-totals">
                            <div class="subscription-split-grand-total">
                                {{ setLabel("afterDiscountFeeLabel") }}:
                                <span>{{ calculateTotalForNewSubscription() | number:'1.0-0' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="addSubscriptionItem" *ngIf="!subscriptionMultiplePaymentModesEnabled">
                <label>{{setLabel("taxLabel")}}</label>
                <input type="number" pInputText [disabled]="true" [(ngModel)]="subscriptionTax" />
            </div>
            <div class="addSubscriptionItem" *ngIf="!subscriptionMultiplePaymentModesEnabled">
                <label>{{setLabel("totalLabel")}}</label>
                <span class="lookLikeInput">{{calculateTotalForNewSubscription()}}</span>
                <i *ngIf="taxType === 'INCLUDING_TAX'">{{setLabel("taxincludedLabel")}}</i>
            </div>
            <div class="addSubscriptionItem">
                <label>{{setLabel("commentLabel")}}</label>
                <textarea [(ngModel)]="description" pInputText class="lookLikeInput"
                    placeholder="Enter your comments"> </textarea>
                <!-- type="number" pInputText min="0" [(ngModel)]="subscriptionDiscount" -->
                <!-- <span class="lookLikeInput">{{calculateTotalForNewSubscription()}}</span> -->
                <!-- <i *ngIf="taxType === 'INCLUDING_TAX'">{{setLabel("taxincludedLabel")}}</i> -->
            </div>
        </div>

        <div class="addSubscriptionFooter">
            <div class="addSubscriptionFooterItem">
                <button pButton icon="pi pi-plus" class="p-button-success" (click)="subscribeService()"
                    [disabled]="isSubscriptionSubscribeDisabled()"
                    [ngClass]="{'disabled-btn': isSubscriptionSubscribeDisabled(), 'enabled-btn': !isSubscriptionSubscribeDisabled()}">
                    {{setLabel("subscribeLabel")}}</button>
            </div>
        </div>
    </p-dialog>
</div>

<app-single-receipt-print [company]="company" [branch]="branch"
    [invoiceMessage]="invoiceMessage"></app-single-receipt-print>

<app-single-receipt-email [company]="company" [branch]="branch" [member]="member"></app-single-receipt-email>

<!-- single month single member add fee receipt -->

<div id="invoice" style="display: none">
    <div class="invoice-box" style="padding: 0px !important;width: 75mm;max-width: 75mm;margin: 0 !important;">
        <div style="width: 75mm; max-width: 75mm; margin-top: 30px; margin-bottom: 20px">
            <div style="display: flex; justify-content: space-around; width: 100%;">
                <ng-container *ngIf="invoiceData.bannerImage.length === 1">
                    <!-- Display single image centered -->
                    <img [src]="config.Server + 'assets/layout/images/companies/' + invoiceData.bannerImage[0]?.image"
                        onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo" style="
                        max-width: 100%;
                        margin-top: 30px;
                        margin-bottom: 20px;
                        max-height: 150px;" />
                </ng-container>

                <ng-container *ngIf="invoiceData.bannerImage.length > 1">
                    <!-- Display multiple images side by side -->
                    <img *ngFor="let banner of invoiceData.bannerImage"
                        [src]="config.Server + 'assets/layout/images/companies/' + banner.image"
                        onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo" style="
                        width: 48%; /* Adjust width to fit two images side by side */
                        margin-top: 30px;
                        margin-bottom: 20px;
                        max-height: 150px;
                        margin-right: 4%; /* Add margin between images */
                        " />
                </ng-container>

            </div>
            <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">
                {{ invoiceData.name }}
            </div>
            <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">
                {{ invoiceData.address }}
            </div>
            <div *ngIf="invoiceData.contact.length === 1"
                style="text-align: center;font-size: 11px;line-height: 15px;color: black;">
                {{ invoiceData.contact[0].contactNumber }}
            </div>

            <div *ngIf="invoiceData.contact.length > 1"
                style="text-align: center;font-size: 11px;line-height: 15px;color: black;">
                <div *ngFor="let contact of invoiceData.contact">
                    {{ contact.contactNumber }}
                </div>
            </div>
            <table
                style="padding:2px;border: 1px solid black;font-size: 9px;line-height: 12px;margin-top: 8px;margin-left: 8px;width: 95%;">
                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align:center;padding: 0px;font-weight: bold; padding-right:33px;"
                            colspan="2">

                            {{ fundInvoice.invoice }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("createdLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: left;padding: 0px;">
                            {{ fundInvoice.date | date : "dd/MM/yyyy" }}
                        </td>

                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                           Start Date:
                        </td>
                        <td style="font-size: 10px;text-align: left;padding: 0px;">
                            {{ formatFeeInvoicePeriodStart(fundInvoice) }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("nextDueLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: left;padding: 0px;">
                            {{ formatFeeInvoicePeriodEnd(fundInvoice) }}

                        </td>

                    </tr>

                </tbody>
            </table>

            <table
                style="border-collapse: collapse;border: 1px solid black;font-size: 9px;line-height: 12px;margin-top: 8px;margin-left: 8px;width: 95%;">
                <tbody>
                    <tr *ngIf="branch.invoiceData.showAddedBy && branch.invoiceData.showAddedBy === true">
                        <td style="font-size: 10px;text-align:left;padding-left:18px;font-weight: bold;">
                            {{setLabel("addedLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;">
                            {{ fundInvoice.enteredBy }}
                        </td>

                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: left;padding: 1px 1px 1px 17px;font-weight: bold;">
                            {{setLabel("packageLabel")}}

                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 1px;">
                            {{fundInvoice.packageName }}
                        </td>

                    </tr>
                </tbody>

            </table>
            <table *ngIf="branch.invoiceData?.showCustomerContact"
                style="border-collapse: collapse;border: 1px solid black;font-size: 9px;line-height:6px;margin-top: 8px;margin-left: 8px;width: 95%;">
                <tr *ngIf="branch.invoiceData.showCustomerContact && branch.invoiceData.showCustomerContact === true">
                    <td style="font-size: 10px;text-align:left;padding-left:18px;font-weight: bold;">
                        {{setLabel("showCustomerContactLabel")}}
                    </td>
                    <td style="font-size: 10px;text-align:left; padding-left:30px;">
                        {{ member.contactDetail?.contact || member.contact }}
                    </td>

                </tr>
            </table>

            <table
                style="border-collapse: collapse;border: 1px solid black;font-size: 9px;line-height:10px;margin-top: 8px;margin-left: 8px;width: 95%;">
                <tbody>
                    <tr style="margin-left:1px;">
                        <td style="font-size: 10px;padding: 1px;font-weight: bold; text-align:left;padding-left: 18px;">
                            {{setLabel("modeOfPaymentDropdownLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align:left; padding:1px 1px 1px 30px;">
                            {{ getInvoicePaymentModeHeader(fundInvoice.paymentMode) }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table
                style="border-collapse: collapse;font-size: 12px;font-size: 9px;margin-top: 3px;line-height: normal;width: 95%;margin-left: 8px;">
                <thead
                    style="border: 1px solid black;text-align: center;font-weight: bold;font-size: 12px;font-size: 9px;background-color: black;color: white;border: 1px solid black;">
                    <tr style="background-color: black; color: white">
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("m#Label")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("nameLabel")}}
                        </th>

                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("typeLabel")}}
                        </th>
                        <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                        <th style="width: 40px; font-size: 9px" *ngIf="hasPrintDiscount(fundInvoice.discount)">{{setLabel("discountLabel")}}</th>
                        <th style="width: 40px; font-size: 9px" *ngIf="hasFeeTax(fundInvoice)">
                            {{setLabel("taxLabel")}}</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.tagNumber }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.name }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                          {{ fundInvoice.status === 'Monthly Fee - Paid' ? 'Package Fee - Paid' : fundInvoice.status }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ fundInvoice.pay | number:'1.0-0'}}
                        </td>
                        <td *ngIf="hasPrintDiscount(fundInvoice.discount)"
                            style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ fundInvoice.discount | number:'1.0-0'}}
                        </td>
                        <td style="font-size: 9px; border: 1px solid black;text-align: center;"
                            *ngIf="hasFeeTax(fundInvoice)">
                            {{ (fundInvoice.tax !== undefined ? fundInvoice.tax : 0) | number:'1.0-0' }}
                        </td>

                    </tr>
                    <tr *ngFor="let modeLine of getSplitPaymentModeLines(fundInvoice.paymentMode)">
                        <td style="font-size: 10px;text-align: left;font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
                            [attr.colspan]="getPrintSubtotalLabelColspan(fundInvoice.discount, fundInvoice)">
                            {{ modeLine.mode }}
                        </td>
                        <td style="font-size: 10px;text-align: center;border-right: 1px solid;border-bottom: 1px solid;"
                            [attr.colspan]="getPrintSubtotalValueColspan(fundInvoice.discount, fundInvoice)">
                            <span>{{ modeLine.amountLabel }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: left;font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
                            [attr.colspan]="getPrintSubtotalLabelColspan(fundInvoice.discount, fundInvoice)">
                            {{setLabel("subTotalLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;border-right: 1px solid;border-bottom: 1px solid;"
                            [attr.colspan]="getPrintSubtotalValueColspan(fundInvoice.discount, fundInvoice)">
                            <span>
                                {{ calculateTotalForSinglePrint(fundInvoice.pay, fundInvoice.tax,
                                fundInvoice.discount, getFeeTaxType(fundInvoice)) }}
                            </span>
                            <i *ngIf="getFeeTaxType(fundInvoice) == 'INCLUDING_TAX'"
                                style="display: block; font-size: 8px;">
                                {{fundInvoice.tax | number:'1.0-0'}} Tax is included in the fee.
                            </i>


                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: left;font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
                            [attr.colspan]="getPrintSubtotalLabelColspan(fundInvoice.discount, fundInvoice)">
                            {{setLabel("balanceRemainingLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;border-right: 1px solid;border-bottom: 1px solid;"
                            [attr.colspan]="getPrintSubtotalValueColspan(fundInvoice.discount, fundInvoice)">
                            <span>
                                {{ getRemainingBalance(fundInvoice.invoice)}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="invoiceMessage"
                style="text-align: center;padding-top: 16px;font-size: 10px;font-family:'Times New Roman';color: black;white-space: wrap; line-height: 18px;">
                {{invoiceMessage}}
            </div>
            <div *ngIf="fundInvoice.SRBInvoiceLines?.length > 1"
                style="text-align: center;margin-top: 10px;font-size: 10px;font-weight: bold;color: black;max-width: 100%;padding: 0 2px;box-sizing: border-box;">
                <div *ngFor="let line of fundInvoice.SRBInvoiceLines"
                    style="margin-top: 2px;word-break: break-all;overflow-wrap: anywhere;white-space: normal;">
                    SRBInvoiceId: {{ line }}
                </div>
            </div>
            <div *ngIf="(!fundInvoice.SRBInvoiceLines || fundInvoice.SRBInvoiceLines.length <= 1) && (fundInvoice.SRBInvoiceLines?.[0] || fundInvoice.SRBInvoiceID)"
                style="text-align: center;margin-top: 10px;font-size: 10px;font-weight: bold;color: black;max-width: 100%;padding: 0 2px;box-sizing: border-box;word-break: break-all;overflow-wrap: anywhere;white-space: normal;">
                SRBInvoiceId: {{ fundInvoice.SRBInvoiceLines?.[0] || fundInvoice.SRBInvoiceID }}
            </div>
            <app-fbr-receipt-block [items]="fbrItems" [logoUrl]="fbrLogoUrl" topSpacing="10px"></app-fbr-receipt-block>
            <div
                style="text-align: center;margin-top: 10px;font-size: 10px;font-weight: bold;color: black;white-space: nowrap;">
                {{setLabel("softwareProvidedByTecfolkLabel")}}
            </div>
        </div>
    </div>
</div>
<!-- max-width: 57mm; -->
<!--multi month single member add fee -->
<div id="multipleInvoices" style="display: none">
    <div class="invoice-box" style="padding: 0px !important;width: 75mm;max-width: 75mm;margin: 0 !important;">
        <div style="width: 57mm; max-width: 57mm; padding-left: 8px;">
            <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                alt="Company Logo"
                style="display: block;margin-left: auto;margin-right: auto;width: 58%;margin-top: 3px;margin-bottom: 2px;max-height: 150px;" />
            <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">
                {{ branch.name }}
            </div>
            <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">
                {{ branch.address }}
            </div>
            <div style="text-align: center;font-size: 11px;line-height: 15px;color: black;">
                {{ branch.phone }}
            </div>
            <table
                style="border-collapse: collapse;border: 1px solid black;font-size: 12px;font-size: 9px;line-height: 12px;margin-top: 8px;">
                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align:center;padding: 0px;font-weight: bold;" colspan="2">

                            {{ firstInvoice }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("createdLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ fundInvoice.date | date : "dd/MM/yyyy" }}
                        </td>

                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("dueDateLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ formatFeeInvoicePeriodStart(fundInvoice) }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("nextDueLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ formatFeeInvoicePeriodEnd(fundInvoice) }}

                        </td>
                    </tr>

                </tbody>
            </table>

            <table
                style="border-collapse: collapse;font-size: 12px;font-size: 9px;margin-top: 3px;line-height: normal;">
                <thead style="border: 1px solid black;text-align: center;font-weight: bold;font-size: 12px;font-size: 9px;background-color: black;color: white;border: 1px solid black;
    ">
                    <tr style="background-color: black;">
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("m#Label")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("nameLabel")}}
                        </th>

                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("typeLabel")}}
                        </th>
                        <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                        <th style="width: 40px; font-size: 9px" *ngIf="hasPrintDiscount(fund.discount)">
                            {{setLabel("discountLabel")}}
                        </th>
                        <th style="width: 40px; font-size: 9px" *ngIf="hasFeeTax(fundInvoice)">
                            {{setLabel("taxLabel")}}</th>

                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let item of fundCollectiveInvoice">
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.tagNumber }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.name }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ item.status }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ item.pay | number:'1.0-0' }}
                        </td>
                       <td style="font-size: 9px;border: 1px solid black;text-align: center;" *ngIf="hasPrintDiscount(fund.discount)">
                            {{ item.discount | number:'1.0-0'}}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;"
                            *ngIf="hasFeeTax(fundInvoice)">
                            {{ (item.tax !== undefined ? item.tax : 0) | number:'1.0-0' }}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td style="font-size: 10px;text-align: center;font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
                            [attr.colspan]="getPrintMonthlySubtotalLabelColspan(fund.discount, fundInvoice)">
                            {{setLabel("subTotalLabel")}}
                        </td>
                        <td
                            style="font-size: 10px;text-align: center;border-right: 1px solid;border-bottom: 1px solid;"
                            [attr.colspan]="getPrintSubtotalValueColspan(fund.discount, fundInvoice)">
                            <span>
                                {{ calculateTotalForSinglePrint(fundInvoice.pay, fundInvoice.tax,
                                fundInvoice.discount, getFeeTaxType(fundInvoice)) }}
                            </span>
                            <i *ngIf="getFeeTaxType(fundInvoice) == 'INCLUDING_TAX'"
                                style="display: block; font-size: 8px;">
                                {{fundInvoice.tax | number:'1.0-0'}} {{setLabel("taxIncludedFeeLabel")}}
                            </i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                style="text-align: center;padding-top: 6px;font-size: 10px;font-weight: bold;color: black;white-space: nowrap;margin-left: 33px;width: 100%;">
                {{setLabel("softwareProvidedByTecfolkLabel")}}
            </div>
        </div>
    </div>
</div>

<div id="invoiceHtmlBody" style="display: none">
    <div
        style="padding: 0px !important;width: 400px;max-width: 400px;margin: auto !important;box-shadow: 0 0 0 0 !important;border: 0px solid #eee !important;">
        <div style="width: 400px; max-width: 400px">
            <table
                style="border-collapse: collapse;font-size: 12px;font-size: 9px;margin-top: 3px;line-height: normal;">
                <thead style="border: 1px solid black;text-align: center;font-weight: bold;font-size: 12px;
                font-size: 9px;background-color: black;color: white;border: 1px solid black;">
                    <tr style="background-color: black;">
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("m#Label")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("nameLabel")}}
                        </th>

                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("typeLabel")}}
                        </th>
                        <th style="width: 40px; font-size: 9px">{{setLabel("amountLabel")}}</th>
                        <th style="width: 40px; font-size: 9px" *ngIf="+(fundInvoice.discount || 0) > 0">{{setLabel("discountLabel")}}</th>
                        <th style="width: 40px; font-size: 9px" *ngIf="fundInvoice.taxCalculationType !== 'NO_TAX'">
                            {{setLabel("taxLabel")}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.tagNumber }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ member.name }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ fundInvoice.status }}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;">
                            {{ fundInvoice.pay | number:'1.0-0'}}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;" *ngIf="+(fundInvoice.discount || 0) > 0">
                            {{ fundInvoice.discount | number:'1.0-0'}}
                        </td>
                        <td style="font-size: 9px;border: 1px solid black;text-align: center;"
                            *ngIf="fundInvoice.taxCalculationType !== 'NO_TAX'">
                            {{ fundInvoice.tax | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 10px;text-align: center;font-weight: bold;border-bottom: 1px solid;border-left: 1px solid;"
                            colspan="2">
                            {{setLabel("subTotalLabel")}}
                        </td>
                        <td
                            style="font-size: 10px;text-align: center;border-right: 1px solid;border-bottom: 1px solid;">
                            <span>
                                {{ calculateTotalForSinglePrint(fundInvoice.pay, fundInvoice.tax,
                                fundInvoice.discount,fundInvoice.taxCalculationType)}}
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="fundInvoice.taxCalculationType == 'INCLUDING_TAX'">
                        <td colspan="6">
                            <i style="display: block; font-size: 8px;">
                                {{fundInvoice.tax | number:'1.0-0'}} {{setLabel("taxIncludedFeeLabel")}}
                            </i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!--Start all invoices print-->
<div id="allInvoice" style="display: none">
    <div class="invoice-box" style="padding: 0px !important;width: 75mm;max-width: 75mm;margin: 0 !important;
">
        <div style="width: 75mm; max-width: 57mm">
            <div style="display: flex; justify-content: space-around; width: 125%;">
                <ng-container *ngIf="invoiceData.bannerImage.length === 1">
                    <!-- Display single image centered -->
                    <img [src]="config.Server + 'assets/layout/images/companies/' + invoiceData.bannerImage[0]?.image"
                        onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo"
                        style="max-width: 100%;margin-top: 30px;margin-bottom: 20px;max-height: 150px;" />
                </ng-container>

                <ng-container *ngIf="invoiceData.bannerImage.length > 1">
                    <!-- Display multiple images side by side -->
                    <img *ngFor="let banner of invoiceData.bannerImage"
                        [src]="config.Server + 'assets/layout/images/companies/' + banner.image"
                        onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo" style="width: 48%; /* Adjust width to fit two images side by side */margin-top: 30px;margin-bottom: 20px;max-height: 150px;/* Add margin between images */
                        " />
                </ng-container>

            </div>
            <div style="text-align: center;margin-left: 49px;font-size: 11px;line-height: 14px;color: black;">
                {{ invoiceData.name }}
            </div>
            <div style="margin-left: 49px;text-align: center;font-size: 11px;line-height: 14px;color: black;">
                {{ invoiceData.address }}
            </div>
            <div *ngIf="invoiceData.contact.length === 1"
                style="margin-left: 49px;text-align: center;font-size: 11px;line-height: 15px;color: black;">
                {{ invoiceData.contact[0].contactNumber }}
            </div>

            <div *ngIf="invoiceData.contact.length > 1"
                style="margin-left: 49px;text-align: center;font-size: 11px;line-height: 15px;color: black;">
                <div *ngFor="let contact of invoiceData.contact">
                    {{ contact.contactNumber }}
                </div>
            </div>

            <table
                style="margin-left: 7px;width: 125%;border-collapse: collapse;font-size: 12px;font-size: 9px;border: 1px solid black;line-height: 12px;margin-top: 8px;">
                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("nameLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("m#Label")}}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;font-weight: bold;">
                            {{setLabel("createdLabel")}}
                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ member.name }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ member.tagNumber }}
                        </td>
                        <td style="font-size: 10px;text-align: center;padding: 0px;">
                            {{ date | date : "dd/MM/yyyy" }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table
                style="margin-left: 7px;width: 125%;border-collapse: collapse;font-size: 12px;font-size: 9px;margin-top: 3px;line-height: normal;">
                <thead
                    style="text-align: center;font-weight: bold;font-size: 12px;font-size: 9px;background-color: black;color: white;">
                    <tr style="background-color: black;color: white;border: 1px solid black;">
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("invoicLabel")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("payLabel")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;" *ngIf="+(printAllFeeTotal.totalDiscountFee || 0) > 0">
                            {{setLabel("discountLabel")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;" *ngIf="!hideTaxInfo">
                            {{setLabel("taxLabel")}}
                        </th>
                        <!-- <th style="width: 40px;  word-break: break-word; font-size: 10px;">Invoice Date</th> -->
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("feeDueDateLabel")}}
                        </th>
                        <th style="width: 40px;word-break: break-word;font-size: 10px;">
                            {{setLabel("statusLabel")}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <span>
                        <tr *ngFor="let item of customerFees">
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.invoice }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.pay | number:'1.0-0'}}
                            </td>
                            <td style="
                                font-size: 9px;
                                border: 1px solid black;
                                text-align: center;" *ngIf="+(printAllFeeTotal.totalDiscountFee || 0) > 0">
                                {{ item.discount | number:'1.0-0' }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                " *ngIf="!hideTaxInfo">
                                {{ (item.tax !== undefined ? item.tax : 0) | number:'1.0-0'}}
                            </td>
                            <!-- <td style="font-size: 9px;border:1px solid black;text-align: center;"> {{item.date | date:
                'dd/MM/yyyy' }}</td> -->
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.day }}/{{ item.month }}/{{ item.year }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.status }}
                            </td>
                        </tr>
                    </span>

                    <tr *ngIf="printAllFeeTotal.totalRegistationFee != 0">
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalRegistrationFeeLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalRegistrationFeeLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: center;
                                    border-right: 1px solid;
                                    border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalRegistationFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="printAllFeeTotal.totalTrainerFee != 0">
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalTrainerFeeLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalTrainerFeeLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: center;
                                    border-right: 1px solid;
                                    border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalTrainerFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="printAllFeeTotal.totalMonthlyFee != 0">
                        <td style="
                            font-size: 10px;
                            text-align: start;
                            font-weight: bold;
                            border-bottom: 1px solid;
                            border-left: 1px solid;
                        " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalMonthlyFeeLabel")}}
                        </td>
                        <td style="
                            font-size: 10px;
                            text-align: start;
                            font-weight: bold;
                            border-bottom: 1px solid;
                            border-left: 1px solid;
                        " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalMonthlyFeeLabel")}}
                        </td>
                        <td style="
                            font-size: 10px;
                            text-align: center;
                            border-right: 1px solid;
                            border-bottom: 1px solid;
                        ">
                            {{ printAllFeeTotal.totalMonthlyFee | number:'1.0-0'}}
                        </td>

                    </tr>
                    <tr *ngIf="+(printAllFeeTotal.totalDiscountFee || 0) > 0">
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalDiscountAmountLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalDiscountAmountLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: center;
                                    border-right: 1px solid;
                                    border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalDiscountFee | number:'1.0-0'}}
                        </td>
                    </tr>

                    <tr *ngIf="printAllFeeTotal.totalFineFee != 0">
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalFineFeeLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalFineFeeLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: center;
                                    border-right: 1px solid;
                                    border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalFineFee | number:'1.0-0'}}
                        </td>
                    </tr>

                    <tr *ngIf="printAllFeeTotal.totalFeeTax != 0 && !hideTaxInfo">
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("totalTaxLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: start;
                                    font-weight: bold;
                                    border-bottom: 1px solid;
                                    border-left: 1px solid;
                                " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("totalTaxLabel")}}
                        </td>
                        <td style="
                                    font-size: 10px;
                                    text-align: center;
                                    border-right: 1px solid;
                                    border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalFeeTax | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-left: 1px solid;
                                border-bottom: 1px solid;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="4" *ngIf="hideTaxInfo">
                            {{setLabel("grandTotalLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-left: 1px solid;
                                border-bottom: 1px solid;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="5" *ngIf="!hideTaxInfo">
                            {{setLabel("grandTotalLabel")}}
                        </td>
                        <td style="
                            font-size: 10px;
                            text-align: center;
                            border-right: 1px solid;
                            border-bottom: 1px solid;
                        ">
                            <span>
                                {{ ((printAllFeeTotal.feeGrandTotal + printAllFeeTotal.grandTotalFeeTax) -
                                printAllFeeTotal.totalDiscountFee) | number:'1.0-0' }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div style="
    text-align: center;
    padding-top: 6px;
    font-size: 10px;
    font-weight: bold;
    color: black;
    white-space: nowrap;
    margin-left: 49px;
">
                {{setLabel("softwareProvidedByTecfolkLabel")}}
            </div>
        </div>
    </div>
</div>

<div id="allInvoiceHtmlBody" style="display: none">
    <div style="
padding: 0px !important;
width: 400px;
max-width: 400px;
margin: auto !important;
box-shadow: 0 0 0 0 !important;
border: 0px solid #eee !important;
">
        <div style="width: 400px; max-width: 400px">
            <table style="
    border-collapse: collapse;
    font-size: 12px;
    font-size: 9px;
    margin-top: 3px;
    line-height: normal;
">
                <thead style="
        text-align: center;
        font-weight: bold;
        font-size: 12px;
        font-size: 9px;
        background-color: black;
        color: white;
    ">
                    <tr style="
            background-color: black;
            color: white;
            border: 1px solid black;
        ">
                        <th style="
                width: 40px;
                word-break: break-word;
                font-size: 10px;
            ">
                            {{setLabel("invoicLabel")}}
                        </th>
                        <th style="
                width: 40px;
                word-break: break-word;
                font-size: 10px;
            ">
                            {{setLabel("payLabel")}}
                        </th>
                        <th style="
                            width: 40px;
                            word-break: break-word;
                            font-size: 10px;" *ngIf="+(printAllFeeTotal.totalDiscountFee || 0) > 0">
                            {{setLabel("discountLabel")}}
                        </th>
                        <th style="
                width: 40px;
                word-break: break-word;
                font-size: 10px;
            " *ngIf="!hideTaxInfo">
                            {{setLabel("taxLabel")}}
                        </th>
                        <th style="
                width: 40px;
                word-break: break-word;
                font-size: 10px;
            ">
                            {{setLabel("feeDueDateLabel")}}
                        </th>
                        <th style="
                width: 40px;
                word-break: break-word;
                font-size: 10px;
            ">
                            {{setLabel("statusLabel")}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <span>
                        <tr *ngFor="let item of customerFees">
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.invoice }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.pay | number:'1.0-0'}}
                            </td>
                            <td style="
                            font-size: 9px;
                            border: 1px solid black;
                            text-align: center;" *ngIf="+(printAllFeeTotal.totalDiscountFee || 0) > 0">
                                {{ item.discount | number:'1.0-0'}}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                " *ngIf="!hideTaxInfo">
                                {{ (item.tax !== undefined ? item.tax : 0) | number:'1.0-0' }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.day }}/{{ item.month }}/{{ item.year }}
                            </td>
                            <td style="
                    font-size: 9px;
                    border: 1px solid black;
                    text-align: center;
                ">
                                {{ item.status }}
                            </td>
                        </tr>
                    </span>

                    <tr *ngIf="printAllFeeTotal.totalRegistationFee != 0">
                        <td *ngIf="!hideTaxInfo"></td>
                        <td></td>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                                " colspan="3">
                            {{setLabel("totalRegistrationFeeLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalRegistationFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="printAllFeeTotal.totalTrainerFee != 0">
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                                " colspan="3">
                            {{setLabel("totalTrainerFeeLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                                ">
                            {{ printAllFeeTotal.totalTrainerFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="printAllFeeTotal.totalMonthlyFee != 0">
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: start;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            {{setLabel("totalMonthlyFeeLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            ">
                            {{ printAllFeeTotal.totalMonthlyFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="printAllFeeTotal.totalFineFee != 0">
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            {{setLabel("totalFineFeeLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            ">
                            {{ printAllFeeTotal.totalFineFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-left: 1px solid;
                                border-bottom: 1px solid;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            {{setLabel("totalDiscountAmountLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            ">
                            {{ printAllFeeTotal.totalDiscountFee | number:'1.0-0'}}
                        </td>
                    </tr>
                    <tr *ngIf="!hideTaxInfo">
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-left: 1px solid;
                                border-bottom: 1px solid;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            {{setLabel("totalTaxLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            ">
                            {{ printAllFeeTotal.totalFeeTax | number:'1.0-0' }}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td *ngIf="!hideTaxInfo"></td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                font-weight: bold;
                                border-left: 1px solid;
                                border-bottom: 1px solid;
                                border-bottom: 1px solid;
                                border-left: 1px solid;
                            " colspan="3">
                            {{setLabel("grandTotalLabel")}}
                        </td>
                        <td style="
                                font-size: 10px;
                                text-align: center;
                                border-right: 1px solid;
                                border-bottom: 1px solid;
                            ">
                            <span>
                                {{ ((printAllFeeTotal.feeGrandTotal + printAllFeeTotal.grandTotalFeeTax) -
                                printAllFeeTotal.totalDiscountFee) | number:'1.0-0' }}
                            </span>
                        </td>
                    </tr>
                    <!-- <tr *ngIf="taxType === 'INCLUDING_TAX'">
                        <td colspan="6">
                            <i style="display: block; font-size: 8px;">
                                {{fundInvoice.tax}} {{setLabel("taxIncludedFeeLabel")}}
                            </i>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</div>

<!--End -->

<!-- PRINT MEMBER INVOICE  -->
<div id="memberinvoice" style="display: none">
    <div class="invoice-box" style="padding: 0px !important;max-width: 330px !important;margin: 0 !important;">
        <table cellpadding="0" cellspacing="0">
            <tr class="top">
                <td colspan="4">
                    <table>
                        <tr>
                            <td class="title" colspan="2" style="text-align: center">
                                <div style="display: flex; justify-content: space-around; width: 100%">
                                    <ng-container *ngIf="invoiceData.bannerImage.length === 1">
                                        <!-- Display single image centered -->
                                        <img [src]="config.Server + 'assets/layout/images/companies/' + invoiceData.bannerImage[0]?.image"
                                            onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo"
                                            style="max-width: 100%;margin-top: 30px;margin-bottom: 20px;max-height: 150px;" />
                                    </ng-container>

                                    <ng-container *ngIf="invoiceData.bannerImage.length > 1">
                                        <!-- Display multiple images side by side -->
                                        <img *ngFor="let banner of invoiceData.bannerImage"
                                            [src]="config.Server + 'assets/layout/images/companies/' + banner.image"
                                            onerror="this.src='assets/layout/images/logoCompany.png'" alt="Company Logo"
                                            style="width: 48%; /* Adjust width to fit two images side by side */margin-top: 30px;margin-bottom: 20px;max-height: 150px;margin-right: 4%; /* Add margin between images */" />
                                    </ng-container>

                                </div>
                                <div
                                    style="display: flex; flex-direction: column; border-bottom: 2px solid gray; line-height: 20px;">
                                    <div style="font-size: 13px;">{{branch.reportPrintData.name}}</div>
                                    <div style="font-size: 13px;">{{branch.reportPrintData.address}}</div>
                                    <div style="font-size: 13px;" *ngIf="branch.reportPrintData.contact.length === 1">
                                        {{setLabel("phoneLabel")}} {{branch.reportPrintData.contact[0].contactNumber}}
                                    </div>
                                    <div style="font-size: 13px;" *ngIf="branch.reportPrintData.contact.length > 1">
                                        <div *ngFor="let contacts of branch.reportPrintData.contact">
                                            {{setLabel("phoneLabel")}} {{ contacts.contactNumber }}
                                        </div>
                                    </div>
                                    <div style="font-size: 13px;">
                                        {{setLabel("createdLabel")}} {{date | date: 'dd/MM/yyyy'}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: center;" colspan="2">
                                <a (click)="openPhoto(member?.profile)">
                                    <img [src]="member.profile
                                        ? config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/members/thumbs/' + member.profile
                                        : 'assets/layout/images/avatarBoyImage.png'"
                                        onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="50"
                                        height="50"
                                        style="border-radius: 50%; object-fit: cover; cursor: pointer; position:relative;border: 2px solid black; width:35%;height:40%;"
                                        alt="member photo" />
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("membershipNoLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.tagNumber }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important"><small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("nameLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.name }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("contactLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.contactDetail.contact }}</td>
                        </tr>
                        <tr *ngIf="member.CNIC">
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("CNICLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.CNIC }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("genderLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.gender }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("packageLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.packageName}}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("registrationFeeLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.registerationFee | number:'1.0-0'}}</td>
                        </tr>
                        <tr *ngIf="!member.customerstrainer.totalFees">
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("trainerFeeLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.customerstrainer.totalFees |
                                number:'1.0-0' }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("monthlyFeeLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.monthFee | number:'1.0-0'}}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("joiningDateLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.joiningDate | date : "mediumDate" }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("dueDateLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important">{{ member.settings.dueDate | date : "mediumDate" }}
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("packageExpiryLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important"> {{ getFormattedDueDate(member.settings?.dueDate) }}
                            </td>
                        </tr>
                        <tr *ngIf="member.email">
                            <td style="text-align: left !important">
                                <small><span
                                        style="font-weight: bold; width: max-content; display: flex;">{{setLabel("emailLabel")}}</span></small>
                            </td>
                            <td style="text-align: left !important;">{{member.email}}</td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
        <hr />
        <div class="logoDiv" style="text-align: center; font-weight: normal; color: black">
            {{setLabel("poweredByLabel")}} &nbsp;
            <a href="http://tecfolk.com/" target="_blank"><img style="width: 66px"
                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="" /></a>
        </div>
        <div style="text-align: center;font-size: smaller;font-weight: normal;color: black;">{{setLabel("phone:Label")}}
        </div>
        <div style="text-align: center;font-size: smaller;font-weight: normal;color: black;">
            {{setLabel("rashid_562@hotmail.comLabel")}}
        </div>
    </div>
</div>
